import xbox from '@/pages/intelligence/assets/svg/marketprofile/xbox.svg'
import playstation from '@/pages/intelligence/assets/svg/marketprofile/playstation.svg'
import nintendo from '@/pages/intelligence/assets/svg/marketprofile/nintendo.svg'


export const testBaseInfo = {
    
    '2021':{
        "co": {
		"online_population_precent": "2.67%",
		"gdp_normal": "301B",
		"gdp_capita_precent": "5.07%",
		"gdp_capita": "15.9K",
		"name": "Colombia",
		"online_population": "15.9K",
		"gdp_normal_precent": "5.73%",
		"total_population": "51.3M",
		"total_population_precent": "0.40%"
	},
	"at": {
		"online_population_precent": "1.15%",
		"gdp_normal": "481B",
		"gdp_capita_precent": "5.42%",
		"gdp_capita": "59.4K",
		"name": "Austria",
		"online_population": "8.25M",
		"gdp_normal_precent": "6.50%",
		"total_population": "9.04M",
		"total_population_precent": "0.21%"
	},
	"cz": {
		"online_population_precent": "1.45%",
		"gdp_normal": "277B",
		"gdp_capita_precent": "6.75%",
		"gdp_capita": "43.7K",
		"name": "Czech Republic",
		"online_population": "9.43M",
		"gdp_normal_precent": "8.26%",
		"total_population": "10.7M",
		"total_population_precent": "0.10%"
	},
	"hu": {
		"online_population_precent": "1.45%",
		"gdp_normal": "181B",
		"gdp_capita_precent": "7.16%",
		"gdp_capita": "36.8K",
		"name": "Hungary",
		"online_population": "8.17M",
		"gdp_normal_precent": "9.37%",
		"total_population": "9.63M",
		"total_population_precent": "-0.30%"
	},
	"no": {
		"online_population_precent": "1.49%",
		"gdp_normal": "446B",
		"gdp_capita_precent": "5.51%",
		"gdp_capita": "36.5K",
		"name": "Norway",
		"online_population": "5.14M",
		"gdp_normal_precent": "3.13%",
		"total_population": "5.47M",
		"total_population_precent": "0.84%"
	},
	"ie": {
		"online_population_precent": "1.41%",
		"gdp_normal": "516B",
		"gdp_capita_precent": "5.40%",
		"gdp_capita": "111K",
		"name": "Ireland",
		"online_population": "4.68M",
		"gdp_normal_precent": "6.91%",
		"total_population": "4.98M",
		"total_population_precent": "0.69%"
	},
	"dk": {
		"online_population_precent": "1.00%",
		"gdp_normal": "397B",
		"gdp_capita_precent": "4.76%",
		"gdp_capita": "63.4K",
		"name": "Denmark",
		"online_population": "5.53M",
		"gdp_normal_precent": "4.92%",
		"total_population": "5.81M",
		"total_population_precent": "0.37%"
	},
	"il": {
		"online_population_precent": "2.85%",
		"gdp_normal": "468B",
		"gdp_capita_precent": "4.59%",
		"gdp_capita": "45.0K",
		"name": "Israel",
		"online_population": "7.88M",
		"gdp_normal_precent": "6.40%",
		"total_population": "8.79M",
		"total_population_precent": "1.50%"
	},
	
	"pt": {
		"online_population_precent": "1.16%",
		"gdp_normal": "252B",
		"gdp_capita_precent": "6.69%",
		"gdp_capita": "36.5K",
		"name": "Portugal",
		"online_population": "8.96M",
		"gdp_normal_precent": "6.76%",
		"total_population": "10.2M",
		"total_population_precent": "-0.27%"
	},
	"ch": {
		"online_population_precent": "1.33%",
		"gdp_normal": "811B",
		"gdp_capita_precent": "4.05%",
		"gdp_capita": "78.1K",
		"name": "Switzerland",
		"online_population": "8.12M",
		"gdp_normal_precent": "5.24%",
		"total_population": "8.72M",
		"total_population_precent": "0.65%"
	},

  de: {
    'Console Players': {
      'Console Players': '43%',
      'Non Console Players': '57%',
    },
    gdp_capita_precent: '4.71%',
    'Esports Audience': {
      'Esports Enthusiasts': '4%',
      'Occasional Viewers': '9%',
      'Non-Esports Audience': '87%',
    },
    Persona: {
      'The Ultimate Gamer': '5%',
      'The All-Round Enthusiast': '4%',
      'The Bargain Buyer': '11%',
      'The Community Gamer': '8%',
      'The Hardware Enthusiast': '7%',
      'The Popcorn Gamer': '5%',
      'The Backseat Viewer': '3%',
      'The Time Filler': '22%',
      'The Lapsed Gamer': '18%',
      'Not a Persona': '17%',
    },
    gdp_capita: '57.0K',
    Income: {
      Low: '44%',
      Middle: '29%',
      High: '20%',
      'Not Stated': '6%',
    },
    'PC Players': {
      'Non PC Players': '54%',
      'PC Players': '46%',
    },
    Gender: {
      Male: '50%',
      Female: '50%',
    },
    online_population_precent: '0.98%',
    gdp_normal: '4.32T',
    Education: {
      Low: '7%',
      Middle: '68%',
      High: '25%',
      'Other/Prefer not to answer': '0%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '46%',
      'Mobile Players': '54%',
    },
    online_population: '76.6M',
    name: 'Germany',
    'Age Combined': {
      '10-20': '16%',
      '21-35': '25%',
      '36-50': '32%',
      '51-65': '27%',
    },
    gdp_normal_precent: '4.95%',
    total_population: '83.9M',
    total_population_precent: '-0.08%',
    'Total Players': {
      'Total Players': '62%',
      'Non Total Players': '38%',
    },
    'Work situation': {
      'Full-time employee': '52%',
      'Part-time employee': '15%',
      'Self-employed or independent': '5%',
      'Full-time homemaker': '4%',
      Student: '7%',
      Unemployed: '6%',
      Retired: '10%',
      'Extended or currently furloughed': '1%',
    },
    Players: {
      'Total Players': '62%',
      'Non Total Players': '38%',
      'Mobile Players': '54%',
      'Non Mobile Players': '46%',
      'PC Players': '46%',
      'Non PC Players': '54%',
      'Console Players': '43%',
      'Non Console Players': '57%',
    },
  },
  be: {
    'Console Players': {
      'Console Players': '35%',
      'Non Console Players': '65%',
    },
    gdp_capita_precent: '4.48%',
    'Esports Audience': {
      'Esports Enthusiasts': '3%',
      'Occasional Viewers': '6%',
      'Non-Esports Audience': '91%',
    },
    Persona: {
      'The Ultimate Gamer': '3%',
      'The All-Round Enthusiast': '4%',
      'The Bargain Buyer': '5%',
      'The Community Gamer': '7%',
      'The Hardware Enthusiast': '5%',
      'The Popcorn Gamer': '6%',
      'The Backseat Viewer': '3%',
      'The Time Filler': '24%',
      'The Lapsed Gamer': '23%',
      'Not a Persona': '20%',
    },
    gdp_capita: '54.0K',
    Income: {
      Low: '43%',
      Middle: '23%',
      High: '12%',
      'Not Stated': '22%',
    },
    'PC Players': {
      'Non PC Players': '65%',
      'PC Players': '35%',
    },
    Gender: {
      Male: '50%',
      Female: '50%',
    },
    online_population_precent: '0.91%',
    gdp_normal: '579B',
    Education: {
      Low: '12%',
      Middle: '59%',
      High: '29%',
      'Other/Prefer not to answer': '0%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '54%',
      'Mobile Players': '46%',
    },
    online_population: '10.9M',
    name: 'Belgium',
    'Age Combined': {
      '10-20': '17%',
      '21-35': '27%',
      '36-50': '29%',
      '51-65': '27%',
    },
    gdp_normal_precent: '5.18%',
    total_population: '11.6M',
    total_population_precent: '0.29%',
    'Total Players': {
      'Total Players': '53%',
      'Non Total Players': '47%',
    },
    'Work situation': {
      'Full-time employee': '48%',
      'Part-time employee': '11%',
      'Self-employed or independent': '4%',
      'Full-time homemaker': '6%',
      Student: '10%',
      Unemployed: '10%',
      Retired: '9%',
      'Extended or currently furloughed': '1%',
    },
    Players: {
      'Total Players': '53%',
      'Non Total Players': '47%',
      'Mobile Players': '46%',
      'Non Mobile Players': '54%',
      'PC Players': '35%',
      'Non PC Players': '65%',
      'Console Players': '35%',
      'Non Console Players': '65%',
    },
  },
  fi: {
    'Console Players': {
      'Console Players': '46%',
      'Non Console Players': '54%',
    },
    gdp_capita_precent: '4.26%',
    'Esports Audience': {
      'Esports Enthusiasts': '6%',
      'Occasional Viewers': '9%',
      'Non-Esports Audience': '85%',
    },
    Persona: {
      'The Ultimate Gamer': '3%',
      'The All-Round Enthusiast': '4%',
      'The Bargain Buyer': '8%',
      'The Community Gamer': '5%',
      'The Hardware Enthusiast': '6%',
      'The Popcorn Gamer': '8%',
      'The Backseat Viewer': '1%',
      'The Time Filler': '25%',
      'The Lapsed Gamer': '27%',
      'Not a Persona': '11%',
    },
    gdp_capita: '51.9K',
    Income: {
      Low: '35%',
      Middle: '31%',
      High: '23%',
      'Not Stated': '11%',
    },
    'PC Players': {
      'Non PC Players': '54%',
      'PC Players': '46%',
    },
    Gender: {
      Male: '51%',
      Female: '49%',
    },
    online_population_precent: '0.98%',
    gdp_normal: '300B',
    Education: {
      Low: '13%',
      Middle: '55%',
      High: '31%',
      'Other/Prefer not to answer': '0%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '48%',
      'Mobile Players': '52%',
    },
    online_population: '5.11M',
    name: 'Finland',
    'Age Combined': {
      '10-20': '18%',
      '21-35': '26%',
      '36-50': '30%',
      '51-65': '26%',
    },
    gdp_normal_precent: '4.58%',
    total_population: '5.55M',
    total_population_precent: '0.11%',
    'Total Players': {
      'Total Players': '60%',
      'Non Total Players': '40%',
    },
    'Work situation': {
      'Full-time employee': '43%',
      'Part-time employee': '10%',
      'Self-employed or independent': '5%',
      'Full-time homemaker': '2%',
      Student: '11%',
      Unemployed: '15%',
      Retired: '13%',
      'Extended or currently furloughed': '1%',
    },
    Players: {
      'Total Players': '60%',
      'Non Total Players': '40%',
      'Mobile Players': '52%',
      'Non Mobile Players': '48%',
      'PC Players': '46%',
      'Non PC Players': '54%',
      'Console Players': '46%',
      'Non Console Players': '54%',
    },
  },
  ru: {
    'Console Players': {
      'Console Players': '29%',
      'Non Console Players': '71%',
    },
    gdp_capita_precent: '5.35%',
    'Esports Audience': {
      'Esports Enthusiasts': '6%',
      'Occasional Viewers': '10%',
      'Non-Esports Audience': '84%',
    },
    Persona: {
      'The Ultimate Gamer': '3%',
      'The All-Round Enthusiast': '3%',
      'The Bargain Buyer': '5%',
      'The Community Gamer': '7%',
      'The Hardware Enthusiast': '4%',
      'The Popcorn Gamer': '15%',
      'The Backseat Viewer': '2%',
      'The Time Filler': '33%',
      'The Lapsed Gamer': '22%',
      'Not a Persona': '7%',
    },
    gdp_capita: '29.5K',
    Income: {
      Low: '11%',
      Middle: '27%',
      High: '57%',
      'Not Stated': '6%',
    },
    'PC Players': {
      'Non PC Players': '41%',
      'PC Players': '59%',
    },
    Gender: {
      Male: '52%',
      Female: '48%',
    },
    online_population_precent: '1.50%',
    gdp_normal: '1.71T',
    Education: {
      Low: '6%',
      Middle: '38%',
      High: '56%',
      'Other/Prefer not to answer': '0%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '38%',
      'Mobile Players': '62%',
    },
    online_population: '123M',
    name: 'Russia',
    'Age Combined': {
      '10-20': '18%',
      '21-35': '37%',
      '36-50': '28%',
      '51-65': '17%',
    },
    gdp_normal_precent: '3.34%',
    total_population: '146M',
    total_population_precent: '-0.10%',
    'Total Players': {
      'Total Players': '69%',
      'Non Total Players': '31%',
    },
    'Work situation': {
      'Full-time employee': '62%',
      'Part-time employee': '7%',
      'Self-employed or independent': '4%',
      'Full-time homemaker': '5%',
      Student: '6%',
      Unemployed: '7%',
      Retired: '7%',
      'Extended or currently furloughed': '2%',
    },
    Players: {
      'Total Players': '69%',
      'Non Total Players': '31%',
      'Mobile Players': '62%',
      'Non Mobile Players': '38%',
      'PC Players': '59%',
      'Non PC Players': '41%',
      'Console Players': '29%',
      'Non Console Players': '71%',
    },
  },
  tw: {
    'Console Players': {
      'Console Players': '61%',
      'Non Console Players': '39%',
    },
    gdp_capita_precent: '5.04%',
    'Esports Audience': {
      'Esports Enthusiasts': '12%',
      'Occasional Viewers': '18%',
      'Non-Esports Audience': '70%',
    },
    Persona: {
      'The Ultimate Gamer': '7%',
      'The All-Round Enthusiast': '5%',
      'The Bargain Buyer': '14%',
      'The Community Gamer': '6%',
      'The Hardware Enthusiast': '8%',
      'The Popcorn Gamer': '22%',
      'The Backseat Viewer': '3%',
      'The Time Filler': '22%',
      'The Lapsed Gamer': '8%',
      'Not a Persona': '5%',
    },
    gdp_capita: '59.4K',
    Income: {
      Low: '25%',
      Middle: '62%',
      High: '8%',
      'Not Stated': '5%',
    },
    'PC Players': {
      'Non PC Players': '29%',
      'PC Players': '71%',
    },
    Gender: {
      Male: '51%',
      Female: '49%',
    },
    online_population_precent: '1.69%',
    gdp_normal: '759B',
    Education: {
      Low: '1%',
      Middle: '33%',
      High: '66%',
      'Other/Prefer not to answer': '1%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '18%',
      'Mobile Players': '82%',
    },
    online_population: '21.2M',
    name: 'Taiwan',
    'Age Combined': {
      '10-20': '24%',
      '21-35': '38%',
      '36-50': '38%',
      '51-65': '0%',
    },
    gdp_normal_precent: '5.88%',
    total_population: '23.9M',
    total_population_precent: '0.13%',
    'Total Players': {
      'Total Players': '84%',
      'Non Total Players': '16%',
    },
    'Work situation': {
      'Full-time employee': '72%',
      'Part-time employee': '4%',
      'Self-employed or independent': '7%',
      'Full-time homemaker': '3%',
      Student: '10%',
      Unemployed: '4%',
      Retired: '0%',
      'Extended or currently furloughed': '0%',
    },
    Players: {
      'Total Players': '84%',
      'Non Total Players': '16%',
      'Mobile Players': '82%',
      'Non Mobile Players': '18%',
      'PC Players': '71%',
      'Non PC Players': '29%',
      'Console Players': '61%',
      'Non Console Players': '39%',
    },
  },
  jp: {
    'Console Players': {
      'Console Players': '43%',
      'Non Console Players': '57%',
    },
    gdp_capita_precent: '4.58%',
    'Esports Audience': {
      'Esports Enthusiasts': '12%',
      'Occasional Viewers': '10%',
      'Non-Esports Audience': '78%',
    },
    Persona: {
      'The Ultimate Gamer': '5%',
      'The All-Round Enthusiast': '5%',
      'The Bargain Buyer': '5%',
      'The Community Gamer': '8%',
      'The Hardware Enthusiast': '8%',
      'The Popcorn Gamer': '9%',
      'The Backseat Viewer': '3%',
      'The Time Filler': '21%',
      'The Lapsed Gamer': '16%',
      'Not a Persona': '20%',
    },
    gdp_capita: '44.6K',
    Income: {
      Low: '25%',
      Middle: '27%',
      High: '35%',
      'Not Stated': '12%',
    },
    'PC Players': {
      'Non PC Players': '65%',
      'PC Players': '35%',
    },
    Gender: {
      Male: '50%',
      Female: '50%',
    },
    online_population_precent: '0.45%',
    gdp_normal: '5.38T',
    Education: {
      Low: '6%',
      Middle: '22%',
      High: '66%',
      'Other/Prefer not to answer': '6%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '48%',
      'Mobile Players': '52%',
    },
    online_population: '115M',
    name: 'Japan',
    'Age Combined': {
      '10-20': '16%',
      '21-35': '29%',
      '36-50': '27%',
      '51-65': '28%',
    },
    gdp_normal_precent: '5.42%',
    total_population: '126M',
    total_population_precent: '-0.39%',
    'Total Players': {
      'Total Players': '61%',
      'Non Total Players': '39%',
    },
    'Work situation': {
      'Full-time employee': '44%',
      'Part-time employee': '14%',
      'Self-employed or independent': '12%',
      'Full-time homemaker': '14%',
      Student: '7%',
      Unemployed: '8%',
      Retired: '1%',
      'Extended or currently furloughed': '1%',
    },
    Players: {
      'Total Players': '61%',
      'Non Total Players': '39%',
      'Mobile Players': '52%',
      'Non Mobile Players': '48%',
      'PC Players': '35%',
      'Non PC Players': '65%',
      'Console Players': '43%',
      'Non Console Players': '57%',
    },
  },
  fr: {
    'Console Players': {
      'Console Players': '53%',
      'Non Console Players': '47%',
    },
    gdp_capita_precent: '4.99%',
    'Esports Audience': {
      'Esports Enthusiasts': '7%',
      'Occasional Viewers': '10%',
      'Non-Esports Audience': '83%',
    },
    Persona: {
      'The Ultimate Gamer': '4%',
      'The All-Round Enthusiast': '5%',
      'The Bargain Buyer': '13%',
      'The Community Gamer': '8%',
      'The Hardware Enthusiast': '7%',
      'The Popcorn Gamer': '6%',
      'The Backseat Viewer': '3%',
      'The Time Filler': '23%',
      'The Lapsed Gamer': '17%',
      'Not a Persona': '13%',
    },
    gdp_capita: '49.5K',
    Income: {
      Low: '38%',
      Middle: '40%',
      High: '15%',
      'Not Stated': '6%',
    },
    'PC Players': {
      'Non PC Players': '53%',
      'PC Players': '47%',
    },
    Gender: {
      Male: '50%',
      Female: '50%',
    },
    online_population_precent: '1.16%',
    gdp_normal: '2.94T',
    Education: {
      Low: '8%',
      Middle: '36%',
      High: '55%',
      'Other/Prefer not to answer': '1%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '42%',
      'Mobile Players': '58%',
    },
    online_population: '59.7M',
    name: 'France',
    'Age Combined': {
      '10-20': '19%',
      '21-35': '27%',
      '36-50': '30%',
      '51-65': '24%',
    },
    gdp_normal_precent: '5.05%',
    total_population: '65.4M',
    total_population_precent: '0.24%',
    'Total Players': {
      'Total Players': '67%',
      'Non Total Players': '33%',
    },
    'Work situation': {
      'Full-time employee': '59%',
      'Part-time employee': '7%',
      'Self-employed or independent': '5%',
      'Full-time homemaker': '4%',
      Student: '9%',
      Unemployed: '8%',
      Retired: '7%',
      'Extended or currently furloughed': '0%',
    },
    Players: {
      'Total Players': '67%',
      'Non Total Players': '33%',
      'Mobile Players': '58%',
      'Non Mobile Players': '42%',
      'PC Players': '47%',
      'Non PC Players': '53%',
      'Console Players': '53%',
      'Non Console Players': '47%',
    },
  },
  nz: {
    'Console Players': {
      'Console Players': '43%',
      'Non Console Players': '57%',
    },
    gdp_capita_precent: '3.91%',
    'Esports Audience': {
      'Esports Enthusiasts': '4%',
      'Occasional Viewers': '7%',
      'Non-Esports Audience': '88%',
    },
    Persona: {
      'The Ultimate Gamer': '4%',
      'The All-Round Enthusiast': '4%',
      'The Bargain Buyer': '8%',
      'The Community Gamer': '6%',
      'The Hardware Enthusiast': '7%',
      'The Popcorn Gamer': '7%',
      'The Backseat Viewer': '2%',
      'The Time Filler': '29%',
      'The Lapsed Gamer': '21%',
      'Not a Persona': '11%',
    },
    gdp_capita: '44.2K',
    Income: {
      Low: '20%',
      Middle: '41%',
      High: '27%',
      'Not Stated': '12%',
    },
    'PC Players': {
      'Non PC Players': '57%',
      'PC Players': '43%',
    },
    Gender: {
      Male: '49%',
      Female: '51%',
    },
    online_population_precent: '1.31%',
    gdp_normal: '243B',
    Education: {
      Low: '12%',
      Middle: '32%',
      High: '54%',
      'Other/Prefer not to answer': '2%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '41%',
      'Mobile Players': '59%',
    },
    online_population: '4.52M',
    name: 'New Zealand',
    'Age Combined': {
      '10-20': '22%',
      '21-35': '28%',
      '36-50': '30%',
      '51-65': '20%',
    },
    gdp_normal_precent: '4.45%',
    total_population: '4.86M',
    total_population_precent: '0.76%',
    'Total Players': {
      'Total Players': '65%',
      'Non Total Players': '35%',
    },
    'Work situation': {
      'Full-time employee': '49%',
      'Part-time employee': '15%',
      'Self-employed or independent': '6%',
      'Full-time homemaker': '7%',
      Student: '8%',
      Unemployed: '10%',
      Retired: '3%',
      'Extended or currently furloughed': '1%',
    },
    Players: {
      'Total Players': '65%',
      'Non Total Players': '35%',
      'Mobile Players': '59%',
      'Non Mobile Players': '41%',
      'PC Players': '43%',
      'Non PC Players': '57%',
      'Console Players': '43%',
      'Non Console Players': '57%',
    },
  },
  sa: {
    'Console Players': {
      'Console Players': '66%',
      'Non Console Players': '34%',
    },
    gdp_capita_precent: '3.69%',
    'Esports Audience': {
      'Esports Enthusiasts': '10%',
      'Occasional Viewers': '14%',
      'Non-Esports Audience': '77%',
    },
    Persona: {
      'The Ultimate Gamer': '11%',
      'The All-Round Enthusiast': '7%',
      'The Bargain Buyer': '21%',
      'The Community Gamer': '7%',
      'The Hardware Enthusiast': '8%',
      'The Popcorn Gamer': '13%',
      'The Backseat Viewer': '4%',
      'The Time Filler': '12%',
      'The Lapsed Gamer': '11%',
      'Not a Persona': '6%',
    },
    gdp_capita: '48.1K',
    Income: {
      Low: '36%',
      Middle: '44%',
      High: '10%',
      'Not Stated': '10%',
    },
    'PC Players': {
      'Non PC Players': '36%',
      'PC Players': '64%',
    },
    Gender: {
      Male: '58%',
      Female: '42%',
    },
    online_population_precent: '2.88%',
    gdp_normal: '805B',
    Education: {
      Low: '22%',
      Middle: '20%',
      High: '57%',
      'Other/Prefer not to answer': '1%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '24%',
      'Mobile Players': '76%',
    },
    online_population: '31.9M',
    name: 'Saudi Arabia',
    'Age Combined': {
      '10-20': '23%',
      '21-35': '40%',
      '36-50': '37%',
      '51-65': '0%',
    },
    gdp_normal_precent: '3.05%',
    total_population: '35.3M',
    total_population_precent: '1.39%',
    'Total Players': {
      'Total Players': '79%',
      'Non Total Players': '21%',
    },
    'Work situation': {
      'Full-time employee': '58%',
      'Part-time employee': '6%',
      'Self-employed or independent': '5%',
      'Full-time homemaker': '14%',
      Student: '9%',
      Unemployed: '6%',
      Retired: '1%',
      'Extended or currently furloughed': '1%',
    },
    Players: {
      'Total Players': '79%',
      'Non Total Players': '21%',
      'Mobile Players': '76%',
      'Non Mobile Players': '24%',
      'PC Players': '64%',
      'Non PC Players': '36%',
      'Console Players': '66%',
      'Non Console Players': '34%',
    },
  },
  br: {
    'Console Players': {
      'Console Players': '55%',
      'Non Console Players': '45%',
    },
    gdp_capita_precent: '4.05%',
    'Esports Audience': {
      'Esports Enthusiasts': '14%',
      'Occasional Viewers': '13%',
      'Non-Esports Audience': '73%',
    },
    Persona: {
      'The Ultimate Gamer': '9%',
      'The All-Round Enthusiast': '5%',
      'The Bargain Buyer': '17%',
      'The Community Gamer': '4%',
      'The Hardware Enthusiast': '5%',
      'The Popcorn Gamer': '19%',
      'The Backseat Viewer': '7%',
      'The Time Filler': '14%',
      'The Lapsed Gamer': '11%',
      'Not a Persona': '9%',
    },
    gdp_capita: '15.6K',
    Income: {
      Low: '16%',
      Middle: '41%',
      High: '38%',
      'Not Stated': '5%',
    },
    'PC Players': {
      'Non PC Players': '41%',
      'PC Players': '59%',
    },
    Gender: {
      Male: '49%',
      Female: '51%',
    },
    online_population_precent: '3.57%',
    gdp_normal: '1.49T',
    Education: {
      Low: '4%',
      Middle: '39%',
      High: '57%',
      'Other/Prefer not to answer': '0%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '32%',
      'Mobile Players': '68%',
    },
    online_population: '160M',
    name: 'Brazil',
    'Age Combined': {
      '10-20': '23%',
      '21-35': '41%',
      '36-50': '25%',
      '51-65': '11%',
    },
    gdp_normal_precent: '8.92%',
    total_population: '214M',
    total_population_precent: '0.62%',
    'Total Players': {
      'Total Players': '73%',
      'Non Total Players': '27%',
    },
    'Work situation': {
      'Full-time employee': '50%',
      'Part-time employee': '9%',
      'Self-employed or independent': '18%',
      'Full-time homemaker': '3%',
      Student: '8%',
      Unemployed: '9%',
      Retired: '4%',
      'Extended or currently furloughed': '0%',
    },
    Players: {
      'Total Players': '73%',
      'Non Total Players': '27%',
      'Mobile Players': '68%',
      'Non Mobile Players': '32%',
      'PC Players': '59%',
      'Non PC Players': '41%',
      'Console Players': '55%',
      'Non Console Players': '45%',
    },
  },
  se: {
    'Console Players': {
      'Console Players': '47%',
      'Non Console Players': '53%',
    },
    gdp_capita_precent: '4.00%',
    'Esports Audience': {
      'Esports Enthusiasts': '5%',
      'Occasional Viewers': '9%',
      'Non-Esports Audience': '86%',
    },
    Persona: {
      'The Ultimate Gamer': '4%',
      'The All-Round Enthusiast': '4%',
      'The Bargain Buyer': '10%',
      'The Community Gamer': '6%',
      'The Hardware Enthusiast': '6%',
      'The Popcorn Gamer': '13%',
      'The Backseat Viewer': '7%',
      'The Time Filler': '21%',
      'The Lapsed Gamer': '18%',
      'Not a Persona': '9%',
    },
    gdp_capita: '55.6K',
    Income: {
      Low: '43%',
      Middle: '27%',
      High: '18%',
      'Not Stated': '12%',
    },
    'PC Players': {
      'Non PC Players': '55%',
      'PC Players': '45%',
    },
    Gender: {
      Male: '51%',
      Female: '49%',
    },
    online_population_precent: '1.07%',
    gdp_normal: '626B',
    Education: {
      Low: '9%',
      Middle: '59%',
      High: '31%',
      'Other/Prefer not to answer': '1%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '42%',
      'Mobile Players': '58%',
    },
    online_population: '9.50M',
    name: 'Sweden',
    'Age Combined': {
      '10-20': '18%',
      '21-35': '27%',
      '36-50': '29%',
      '51-65': '26%',
    },
    gdp_normal_precent: '5.40%',
    total_population: '10.2M',
    total_population_precent: '0.57%',
    'Total Players': {
      'Total Players': '65%',
      'Non Total Players': '35%',
    },
    'Work situation': {
      'Full-time employee': '48%',
      'Part-time employee': '13%',
      'Self-employed or independent': '3%',
      'Full-time homemaker': '2%',
      Student: '12%',
      Unemployed: '12%',
      Retired: '8%',
      'Extended or currently furloughed': '1%',
    },
    Players: {
      'Total Players': '65%',
      'Non Total Players': '35%',
      'Mobile Players': '58%',
      'Non Mobile Players': '42%',
      'PC Players': '45%',
      'Non PC Players': '55%',
      'Console Players': '47%',
      'Non Console Players': '53%',
    },
  },
  sg: {
    'Console Players': {
      'Console Players': '52%',
      'Non Console Players': '48%',
    },
    gdp_capita_precent: '4.09%',
    'Esports Audience': {
      'Esports Enthusiasts': '8%',
      'Occasional Viewers': '10%',
      'Non-Esports Audience': '82%',
    },
    Persona: {
      'The Ultimate Gamer': '3%',
      'The All-Round Enthusiast': '6%',
      'The Bargain Buyer': '18%',
      'The Community Gamer': '6%',
      'The Hardware Enthusiast': '8%',
      'The Popcorn Gamer': '11%',
      'The Backseat Viewer': '2%',
      'The Time Filler': '25%',
      'The Lapsed Gamer': '13%',
      'Not a Persona': '8%',
    },
    gdp_capita: '103K',
    Income: {
      Low: '24%',
      Middle: '23%',
      High: '48%',
      'Not Stated': '5%',
    },
    'PC Players': {
      'Non PC Players': '41%',
      'PC Players': '59%',
    },
    Gender: {
      Male: '49%',
      Female: '51%',
    },
    online_population_precent: '1.78%',
    gdp_normal: '374B',
    Education: {
      Low: '3%',
      Middle: '28%',
      High: '69%',
      'Other/Prefer not to answer': '1%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '26%',
      'Mobile Players': '74%',
    },
    online_population: '5.40M',
    name: 'Singapore',
    'Age Combined': {
      '10-20': '24%',
      '21-35': '36%',
      '36-50': '40%',
      '51-65': '0%',
    },
    gdp_normal_precent: '4.69%',
    total_population: '5.90M',
    total_population_precent: '0.79%',
    'Total Players': {
      'Total Players': '77%',
      'Non Total Players': '23%',
    },
    'Work situation': {
      'Full-time employee': '71%',
      'Part-time employee': '5%',
      'Self-employed or independent': '6%',
      'Full-time homemaker': '3%',
      Student: '9%',
      Unemployed: '5%',
      Retired: '0%',
      'Extended or currently furloughed': '0%',
    },
    Players: {
      'Total Players': '77%',
      'Non Total Players': '23%',
      'Mobile Players': '74%',
      'Non Mobile Players': '26%',
      'PC Players': '59%',
      'Non PC Players': '41%',
      'Console Players': '52%',
      'Non Console Players': '48%',
    },
  },
  id: {
    'Console Players': {
      'Console Players': '61%',
      'Non Console Players': '39%',
    },
    gdp_capita_precent: '7.12%',
    'Esports Audience': {
      'Esports Enthusiasts': '29%',
      'Occasional Viewers': '17%',
      'Non-Esports Audience': '55%',
    },
    Persona: {
      'The Ultimate Gamer': '11%',
      'The All-Round Enthusiast': '6%',
      'The Bargain Buyer': '16%',
      'The Community Gamer': '5%',
      'The Hardware Enthusiast': '8%',
      'The Popcorn Gamer': '22%',
      'The Backseat Viewer': '4%',
      'The Time Filler': '11%',
      'The Lapsed Gamer': '10%',
      'Not a Persona': '6%',
    },
    gdp_capita: '12.9K',
    Income: {
      Low: '10%',
      Middle: '19%',
      High: '68%',
      'Not Stated': '3%',
    },
    'PC Players': {
      'Non PC Players': '32%',
      'PC Players': '68%',
    },
    Gender: {
      Male: '51%',
      Female: '49%',
    },
    online_population_precent: '4.36%',
    gdp_normal: '1.16T',
    Education: {
      Low: '5%',
      Middle: '40%',
      High: '54%',
      'Other/Prefer not to answer': '1%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '22%',
      'Mobile Players': '78%',
    },
    online_population: '185M',
    name: 'Indonesia',
    'Age Combined': {
      '10-20': '35%',
      '21-35': '42%',
      '36-50': '23%',
      '51-65': '0%',
    },
    gdp_normal_precent: '8.35%',
    total_population: '276M',
    total_population_precent: '0.99%',
    'Total Players': {
      'Total Players': '79%',
      'Non Total Players': '21%',
    },
    'Work situation': {
      'Full-time employee': '49%',
      'Part-time employee': '12%',
      'Self-employed or independent': '16%',
      'Full-time homemaker': '7%',
      Student: '11%',
      Unemployed: '4%',
      Retired: '0%',
      'Extended or currently furloughed': '0%',
    },
    Players: {
      'Total Players': '79%',
      'Non Total Players': '21%',
      'Mobile Players': '78%',
      'Non Mobile Players': '22%',
      'PC Players': '68%',
      'Non PC Players': '32%',
      'Console Players': '61%',
      'Non Console Players': '39%',
    },
  },
  gb: {
    'Console Players': {
      'Console Players': '48%',
      'Non Console Players': '52%',
    },
    gdp_capita_precent: '5.40%',
    'Esports Audience': {
      'Esports Enthusiasts': '6%',
      'Occasional Viewers': '7%',
      'Non-Esports Audience': '87%',
    },
    Persona: {
      'The Ultimate Gamer': '3%',
      'The All-Round Enthusiast': '6%',
      'The Bargain Buyer': '11%',
      'The Community Gamer': '8%',
      'The Hardware Enthusiast': '6%',
      'The Popcorn Gamer': '5%',
      'The Backseat Viewer': '3%',
      'The Time Filler': '22%',
      'The Lapsed Gamer': '18%',
      'Not a Persona': '16%',
    },
    gdp_capita: '47.1K',
    Income: {
      Low: '34%',
      Middle: '32%',
      High: '27%',
      'Not Stated': '7%',
    },
    'PC Players': {
      'Non PC Players': '59%',
      'PC Players': '41%',
    },
    Gender: {
      Male: '50%',
      Female: '50%',
    },
    online_population_precent: '1.18%',
    gdp_normal: '3.12T',
    Education: {
      Low: '4%',
      Middle: '40%',
      High: '54%',
      'Other/Prefer not to answer': '1%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '44%',
      'Mobile Players': '56%',
    },
    online_population: '63.1M',
    name: 'United Kingdom',
    'Age Combined': {
      '10-20': '19%',
      '21-35': '28%',
      '36-50': '30%',
      '51-65': '24%',
    },
    gdp_normal_precent: '5.69%',
    total_population: '68.2M',
    total_population_precent: '0.41%',
    'Total Players': {
      'Total Players': '63%',
      'Non Total Players': '37%',
    },
    'Work situation': {
      'Full-time employee': '51%',
      'Part-time employee': '14%',
      'Self-employed or independent': '6%',
      'Full-time homemaker': '7%',
      Student: '4%',
      Unemployed: '9%',
      Retired: '6%',
      'Extended or currently furloughed': '3%',
    },
    Players: {
      'Total Players': '63%',
      'Non Total Players': '37%',
      'Mobile Players': '56%',
      'Non Mobile Players': '44%',
      'PC Players': '41%',
      'Non PC Players': '59%',
      'Console Players': '48%',
      'Non Console Players': '52%',
    },
  },
  ca: {
    'Console Players': {
      'Console Players': '45%',
      'Non Console Players': '55%',
    },
    gdp_capita_precent: '4.65%',
    'Esports Audience': {
      'Esports Enthusiasts': '3%',
      'Occasional Viewers': '6%',
      'Non-Esports Audience': '91%',
    },
    Persona: {
      'The Ultimate Gamer': '4%',
      'The All-Round Enthusiast': '5%',
      'The Bargain Buyer': '8%',
      'The Community Gamer': '6%',
      'The Hardware Enthusiast': '7%',
      'The Popcorn Gamer': '5%',
      'The Backseat Viewer': '3%',
      'The Time Filler': '27%',
      'The Lapsed Gamer': '20%',
      'Not a Persona': '14%',
    },
    gdp_capita: '51.7K',
    Income: {
      Low: '35%',
      Middle: '31%',
      High: '28%',
      'Not Stated': '6%',
    },
    'PC Players': {
      'Non PC Players': '57%',
      'PC Players': '43%',
    },
    Gender: {
      Male: '50%',
      Female: '50%',
    },
    online_population_precent: '1.31%',
    gdp_normal: '1.88T',
    Education: {
      Low: '4%',
      Middle: '20%',
      High: '75%',
      'Other/Prefer not to answer': '1%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '46%',
      'Mobile Players': '54%',
    },
    online_population: '34.5M',
    name: 'Canada',
    'Age Combined': {
      '10-20': '18%',
      '21-35': '27%',
      '36-50': '30%',
      '51-65': '25%',
    },
    gdp_normal_precent: '6.67%',
    total_population: '38.1M',
    total_population_precent: '0.83%',
    'Total Players': {
      'Total Players': '63%',
      'Non Total Players': '37%',
    },
    'Work situation': {
      'Full-time employee': '51%',
      'Part-time employee': '10%',
      'Self-employed or independent': '6%',
      'Full-time homemaker': '6%',
      Student: '7%',
      Unemployed: '8%',
      Retired: '11%',
      'Extended or currently furloughed': '1%',
    },
    Players: {
      'Total Players': '63%',
      'Non Total Players': '37%',
      'Mobile Players': '54%',
      'Non Mobile Players': '46%',
      'PC Players': '43%',
      'Non PC Players': '57%',
      'Console Players': '45%',
      'Non Console Players': '55%',
    },
  },
  us: {
    'Console Players': {
      'Console Players': '48%',
      'Non Console Players': '52%',
    },
    gdp_capita_precent: '4.17%',
    'Esports Audience': {
      'Esports Enthusiasts': '9%',
      'Occasional Viewers': '8%',
      'Non-Esports Audience': '84%',
    },
    Persona: {
      'The Ultimate Gamer': '8%',
      'The All-Round Enthusiast': '5%',
      'The Bargain Buyer': '15%',
      'The Community Gamer': '8%',
      'The Hardware Enthusiast': '6%',
      'The Popcorn Gamer': '4%',
      'The Backseat Viewer': '3%',
      'The Time Filler': '18%',
      'The Lapsed Gamer': '15%',
      'Not a Persona': '18%',
    },
    gdp_capita: '68.3K',
    Income: {
      Low: '29%',
      Middle: '25%',
      High: '40%',
      'Not Stated': '5%',
    },
    'PC Players': {
      'Non PC Players': '53%',
      'PC Players': '47%',
    },
    Gender: {
      Male: '50%',
      Female: '50%',
    },
    online_population_precent: '1.36%',
    gdp_normal: '22.7T',
    Education: {
      Low: '6%',
      Middle: '46%',
      High: '47%',
      'Other/Prefer not to answer': '1%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '41%',
      'Mobile Players': '59%',
    },
    online_population: '288M',
    name: 'United States',
    'Age Combined': {
      '10-20': '19%',
      '21-35': '27%',
      '36-50': '29%',
      '51-65': '25%',
    },
    gdp_normal_precent: '4.78%',
    total_population: '333M',
    total_population_precent: '0.56%',
    'Total Players': {
      'Total Players': '64%',
      'Non Total Players': '36%',
    },
    'Work situation': {
      'Full-time employee': '50%',
      'Part-time employee': '9%',
      'Self-employed or independent': '5%',
      'Full-time homemaker': '7%',
      Student: '5%',
      Unemployed: '11%',
      Retired: '12%',
      'Extended or currently furloughed': '1%',
    },
    Players: {
      'Total Players': '64%',
      'Non Total Players': '36%',
      'Mobile Players': '59%',
      'Non Mobile Players': '41%',
      'PC Players': '47%',
      'Non PC Players': '53%',
      'Console Players': '48%',
      'Non Console Players': '52%',
    },
  },
  ae: {
    'Console Players': {
      'Console Players': '64%',
      'Non Console Players': '36%',
    },
    gdp_capita_precent: '1.79%',
    'Esports Audience': {
      'Esports Enthusiasts': '7%',
      'Occasional Viewers': '11%',
      'Non-Esports Audience': '81%',
    },
    Persona: {
      'The Ultimate Gamer': '5%',
      'The All-Round Enthusiast': '8%',
      'The Bargain Buyer': '23%',
      'The Community Gamer': '8%',
      'The Hardware Enthusiast': '7%',
      'The Popcorn Gamer': '11%',
      'The Backseat Viewer': '5%',
      'The Time Filler': '14%',
      'The Lapsed Gamer': '11%',
      'Not a Persona': '6%',
    },
    gdp_capita: '59.8K',
    Income: {
      Low: '20%',
      Middle: '36%',
      High: '37%',
      'Not Stated': '7%',
    },
    'PC Players': {
      'Non PC Players': '36%',
      'PC Players': '64%',
    },
    Gender: {
      Male: '71%',
      Female: '29%',
    },
    online_population_precent: '1.16%',
    gdp_normal: '402B',
    Education: {
      Low: '3%',
      Middle: '30%',
      High: '66%',
      'Other/Prefer not to answer': '1%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '27%',
      'Mobile Players': '73%',
    },
    online_population: '9.48M',
    name: 'United Arab Emirates',
    'Age Combined': {
      '10-20': '17%',
      '21-35': '53%',
      '36-50': '30%',
      '51-65': '0%',
    },
    gdp_normal_precent: '2.20%',
    total_population: '9.99M',
    total_population_precent: '0.87%',
    'Total Players': {
      'Total Players': '77%',
      'Non Total Players': '23%',
    },
    'Work situation': {
      'Full-time employee': '69%',
      'Part-time employee': '7%',
      'Self-employed or independent': '6%',
      'Full-time homemaker': '6%',
      Student: '6%',
      Unemployed: '5%',
      Retired: '0%',
      'Extended or currently furloughed': '0%',
    },
    Players: {
      'Total Players': '77%',
      'Non Total Players': '23%',
      'Mobile Players': '73%',
      'Non Mobile Players': '27%',
      'PC Players': '64%',
      'Non PC Players': '36%',
      'Console Players': '64%',
      'Non Console Players': '36%',
    },
  },
  in: {
    'Console Players': {
      'Console Players': '59%',
      'Non Console Players': '41%',
    },
    gdp_capita_precent: '8.28%',
    'Esports Audience': {
      'Esports Enthusiasts': '31%',
      'Occasional Viewers': '16%',
      'Non-Esports Audience': '53%',
    },
    Persona: {
      'The Ultimate Gamer': '16%',
      'The All-Round Enthusiast': '7%',
      'The Bargain Buyer': '32%',
      'The Community Gamer': '8%',
      'The Hardware Enthusiast': '7%',
      'The Popcorn Gamer': '10%',
      'The Backseat Viewer': '3%',
      'The Time Filler': '8%',
      'The Lapsed Gamer': '5%',
      'Not a Persona': '3%',
    },
    gdp_capita: '7.33K',
    Income: {
      Low: '11%',
      Middle: '33%',
      High: '53%',
      'Not Stated': '3%',
    },
    'PC Players': {
      'Non PC Players': '16%',
      'PC Players': '84%',
    },
    Gender: {
      Male: '52%',
      Female: '48%',
    },
    online_population_precent: '6.34%',
    gdp_normal: '3.05T',
    Education: {
      Low: '4%',
      Middle: '14%',
      High: '81%',
      'Other/Prefer not to answer': '0%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '12%',
      'Mobile Players': '88%',
    },
    online_population: '693M',
    name: 'India',
    'Age Combined': {
      '10-20': '32%',
      '21-35': '38%',
      '36-50': '30%',
      '51-65': '0%',
    },
    gdp_normal_precent: '8.51%',
    total_population: '1.39B',
    total_population_precent: '0.94%',
    'Total Players': {
      'Total Players': '89%',
      'Non Total Players': '11%',
    },
    'Work situation': {
      'Full-time employee': '68%',
      'Part-time employee': '5%',
      'Self-employed or independent': '9%',
      'Full-time homemaker': '3%',
      Student: '13%',
      Unemployed: '1%',
      Retired: '0%',
      'Extended or currently furloughed': '0%',
    },
    Players: {
      'Total Players': '89%',
      'Non Total Players': '11%',
      'Mobile Players': '88%',
      'Non Mobile Players': '12%',
      'PC Players': '84%',
      'Non PC Players': '16%',
      'Console Players': '59%',
      'Non Console Players': '41%',
    },
  },
  za: {
    'Console Players': {
      'Console Players': '62%',
      'Non Console Players': '38%',
    },
    gdp_capita_precent: '2.42%',
    'Esports Audience': {
      'Esports Enthusiasts': '10%',
      'Occasional Viewers': '11%',
      'Non-Esports Audience': '79%',
    },
    Persona: {
      'The Ultimate Gamer': '6%',
      'The All-Round Enthusiast': '6%',
      'The Bargain Buyer': '19%',
      'The Community Gamer': '7%',
      'The Hardware Enthusiast': '8%',
      'The Popcorn Gamer': '14%',
      'The Backseat Viewer': '2%',
      'The Time Filler': '22%',
      'The Lapsed Gamer': '10%',
      'Not a Persona': '4%',
    },
    gdp_capita: '12.4K',
    Income: {
      Low: '22%',
      Middle: '29%',
      High: '43%',
      'Not Stated': '6%',
    },
    'PC Players': {
      'Non PC Players': '33%',
      'PC Players': '67%',
    },
    Gender: {
      Male: '51%',
      Female: '49%',
    },
    online_population_precent: '4.21%',
    gdp_normal: '330B',
    Education: {
      Low: '11%',
      Middle: '62%',
      High: '27%',
      'Other/Prefer not to answer': '1%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '20%',
      'Mobile Players': '80%',
    },
    online_population: '39.5M',
    name: 'South Africa',
    'Age Combined': {
      '10-20': '31%',
      '21-35': '46%',
      '36-50': '23%',
      '51-65': '0%',
    },
    gdp_normal_precent: '3.78%',
    total_population: '60.0M',
    total_population_precent: '1.17%',
    'Total Players': {
      'Total Players': '83%',
      'Non Total Players': '17%',
    },
    'Work situation': {
      'Full-time employee': '50%',
      'Part-time employee': '11%',
      'Self-employed or independent': '11%',
      'Full-time homemaker': '2%',
      Student: '14%',
      Unemployed: '11%',
      Retired: '0%',
      'Extended or currently furloughed': '0%',
    },
    Players: {
      'Total Players': '83%',
      'Non Total Players': '17%',
      'Mobile Players': '80%',
      'Non Mobile Players': '20%',
      'PC Players': '67%',
      'Non PC Players': '33%',
      'Console Players': '62%',
      'Non Console Players': '38%',
    },
  },
  kr: {
    'Console Players': {
      'Console Players': '46%',
      'Non Console Players': '54%',
    },
    gdp_capita_precent: '4.95%',
    'Esports Audience': {
      'Esports Enthusiasts': '16%',
      'Occasional Viewers': '14%',
      'Non-Esports Audience': '70%',
    },
    Persona: {
      'The Ultimate Gamer': '4%',
      'The All-Round Enthusiast': '5%',
      'The Bargain Buyer': '12%',
      'The Community Gamer': '8%',
      'The Hardware Enthusiast': '8%',
      'The Popcorn Gamer': '15%',
      'The Backseat Viewer': '4%',
      'The Time Filler': '21%',
      'The Lapsed Gamer': '9%',
      'Not a Persona': '17%',
    },
    gdp_capita: '47.0K',
    Income: {
      Low: '8%',
      Middle: '50%',
      High: '38%',
      'Not Stated': '4%',
    },
    'PC Players': {
      'Non PC Players': '43%',
      'PC Players': '57%',
    },
    Gender: {
      Male: '52%',
      Female: '48%',
    },
    online_population_precent: '0.56%',
    gdp_normal: '1.81T',
    Education: {
      Low: '6%',
      Middle: '24%',
      High: '69%',
      'Other/Prefer not to answer': '1%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '31%',
      'Mobile Players': '69%',
    },
    online_population: '48.9M',
    name: 'South Korea',
    'Age Combined': {
      '10-20': '20%',
      '21-35': '32%',
      '36-50': '32%',
      '51-65': '17%',
    },
    gdp_normal_precent: '4.36%',
    total_population: '51.3M',
    total_population_precent: '0.04%',
    'Total Players': {
      'Total Players': '71%',
      'Non Total Players': '29%',
    },
    'Work situation': {
      'Full-time employee': '52%',
      'Part-time employee': '9%',
      'Self-employed or independent': '7%',
      'Full-time homemaker': '9%',
      Student: '12%',
      Unemployed: '9%',
      Retired: '1%',
      'Extended or currently furloughed': '1%',
    },
    Players: {
      'Total Players': '71%',
      'Non Total Players': '29%',
      'Mobile Players': '69%',
      'Non Mobile Players': '31%',
      'PC Players': '57%',
      'Non PC Players': '43%',
      'Console Players': '46%',
      'Non Console Players': '54%',
    },
  },
  cn: {
    'Console Players': {
      'Console Players': '27%',
      'Non Console Players': '73%',
    },
    gdp_capita_precent: '7.67%',
    'Esports Audience': {
      'Esports Enthusiasts': '34%',
      'Occasional Viewers': '19%',
      'Non-Esports Audience': '47%',
    },
    Persona: {
      'The Ultimate Gamer': '12%',
      'The All-Round Enthusiast': '7%',
      'The Bargain Buyer': '20%',
      'The Community Gamer': '6%',
      'The Hardware Enthusiast': '10%',
      'The Popcorn Gamer': '15%',
      'The Backseat Viewer': '4%',
      'The Time Filler': '9%',
      'The Lapsed Gamer': '7%',
      'Not a Persona': '10%',
    },
    gdp_capita: '18.9K',
    Income: {
      Low: '9%',
      Middle: '75%',
      High: '15%',
      'Not Stated': '1%',
    },
    'PC Players': {
      'Non PC Players': '28%',
      'PC Players': '72%',
    },
    Gender: {
      Male: '53%',
      Female: '47%',
    },
    online_population_precent: '2.91%',
    gdp_normal: '16.6T',
    Education: {
      Low: '1%',
      Middle: '12%',
      High: '87%',
      'Other/Prefer not to answer': '0%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '22%',
      'Mobile Players': '78%',
    },
    online_population: '977M',
    name: 'China',
    'Age Combined': {
      '10-20': '25%',
      '21-35': '43%',
      '36-50': '32%',
      '51-65': '0%',
    },
    gdp_normal_precent: '8.03%',
    total_population: '1.44B',
    total_population_precent: '0.27%',
    'Total Players': {
      'Total Players': '79%',
      'Non Total Players': '21%',
    },
    'Work situation': {
      'Full-time employee': '76%',
      'Part-time employee': '2%',
      'Self-employed or independent': '5%',
      'Full-time homemaker': '1%',
      Student: '15%',
      Unemployed: '1%',
      Retired: '0%',
      'Extended or currently furloughed': '0%',
    },
    Players: {
      'Total Players': '79%',
      'Non Total Players': '21%',
      'Mobile Players': '78%',
      'Non Mobile Players': '22%',
      'PC Players': '72%',
      'Non PC Players': '28%',
      'Console Players': '27%',
      'Non Console Players': '73%',
    },
  },
  it: {
    'Console Players': {
      'Console Players': '57%',
      'Non Console Players': '43%',
    },
    gdp_capita_precent: '4.98%',
    'Esports Audience': {
      'Esports Enthusiasts': '10%',
      'Occasional Viewers': '10%',
      'Non-Esports Audience': '80%',
    },
    Persona: {
      'The Ultimate Gamer': '7%',
      'The All-Round Enthusiast': '4%',
      'The Bargain Buyer': '14%',
      'The Community Gamer': '6%',
      'The Hardware Enthusiast': '10%',
      'The Popcorn Gamer': '11%',
      'The Backseat Viewer': '3%',
      'The Time Filler': '20%',
      'The Lapsed Gamer': '14%',
      'Not a Persona': '11%',
    },
    gdp_capita: '43.4K',
    Income: {
      Low: '59%',
      Middle: '22%',
      High: '9%',
      'Not Stated': '9%',
    },
    'PC Players': {
      'Non PC Players': '43%',
      'PC Players': '57%',
    },
    Gender: {
      Male: '50%',
      Female: '50%',
    },
    online_population_precent: '0.96%',
    gdp_normal: '2.11T',
    Education: {
      Low: '8%',
      Middle: '48%',
      High: '44%',
      'Other/Prefer not to answer': '0%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '34%',
      'Mobile Players': '66%',
    },
    online_population: '53.9M',
    name: 'Italy',
    'Age Combined': {
      '10-20': '15%',
      '21-35': '26%',
      '36-50': '34%',
      '51-65': '25%',
    },
    gdp_normal_precent: '4.40%',
    total_population: '60.4M',
    total_population_precent: '-0.18%',
    'Total Players': {
      'Total Players': '71%',
      'Non Total Players': '29%',
    },
    'Work situation': {
      'Full-time employee': '46%',
      'Part-time employee': '10%',
      'Self-employed or independent': '13%',
      'Full-time homemaker': '8%',
      Student: '10%',
      Unemployed: '10%',
      Retired: '3%',
      'Extended or currently furloughed': '0%',
    },
    Players: {
      'Total Players': '71%',
      'Non Total Players': '29%',
      'Mobile Players': '66%',
      'Non Mobile Players': '34%',
      'PC Players': '57%',
      'Non PC Players': '43%',
      'Console Players': '57%',
      'Non Console Players': '43%',
    },
  },
  mx: {
    'Console Players': {
      'Console Players': '70%',
      'Non Console Players': '30%',
    },
    gdp_capita_precent: '3.98%',
    'Esports Audience': {
      'Esports Enthusiasts': '13%',
      'Occasional Viewers': '14%',
      'Non-Esports Audience': '73%',
    },
    Persona: {
      'The Ultimate Gamer': '10%',
      'The All-Round Enthusiast': '6%',
      'The Bargain Buyer': '23%',
      'The Community Gamer': '6%',
      'The Hardware Enthusiast': '9%',
      'The Popcorn Gamer': '11%',
      'The Backseat Viewer': '2%',
      'The Time Filler': '17%',
      'The Lapsed Gamer': '11%',
      'Not a Persona': '5%',
    },
    gdp_capita: '20.3K',
    Income: {
      Low: '18%',
      Middle: '29%',
      High: '48%',
      'Not Stated': '6%',
    },
    'PC Players': {
      'Non PC Players': '34%',
      'PC Players': '66%',
    },
    Gender: {
      Male: '50%',
      Female: '50%',
    },
    online_population_precent: '3.35%',
    gdp_normal: '1.19T',
    Education: {
      Low: '1%',
      Middle: '40%',
      High: '58%',
      'Other/Prefer not to answer': '1%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '21%',
      'Mobile Players': '79%',
    },
    online_population: '98.1M',
    name: 'Mexico',
    'Age Combined': {
      '10-20': '34%',
      '21-35': '36%',
      '36-50': '22%',
      '51-65': '8%',
    },
    gdp_normal_precent: '4.72%',
    total_population: '130M',
    total_population_precent: '0.98%',
    'Total Players': {
      'Total Players': '82%',
      'Non Total Players': '18%',
    },
    'Work situation': {
      'Full-time employee': '55%',
      'Part-time employee': '11%',
      'Self-employed or independent': '11%',
      'Full-time homemaker': '5%',
      Student: '12%',
      Unemployed: '5%',
      Retired: '1%',
      'Extended or currently furloughed': '0%',
    },
    Players: {
      'Total Players': '82%',
      'Non Total Players': '18%',
      'Mobile Players': '79%',
      'Non Mobile Players': '21%',
      'PC Players': '66%',
      'Non PC Players': '34%',
      'Console Players': '70%',
      'Non Console Players': '30%',
    },
  },
  my: {
    'Console Players': {
      'Console Players': '55%',
      'Non Console Players': '45%',
    },
    gdp_capita_precent: '6.90%',
    'Esports Audience': {
      'Esports Enthusiasts': '17%',
      'Occasional Viewers': '14%',
      'Non-Esports Audience': '69%',
    },
    Persona: {
      'The Ultimate Gamer': '6%',
      'The All-Round Enthusiast': '7%',
      'The Bargain Buyer': '20%',
      'The Community Gamer': '6%',
      'The Hardware Enthusiast': '7%',
      'The Popcorn Gamer': '16%',
      'The Backseat Viewer': '4%',
      'The Time Filler': '18%',
      'The Lapsed Gamer': '10%',
      'Not a Persona': '6%',
    },
    gdp_capita: '29.3K',
    Income: {
      Low: '24%',
      Middle: '24%',
      High: '48%',
      'Not Stated': '5%',
    },
    'PC Players': {
      'Non PC Players': '35%',
      'PC Players': '65%',
    },
    Gender: {
      Male: '51%',
      Female: '49%',
    },
    online_population_precent: '2.67%',
    gdp_normal: '387B',
    Education: {
      Low: '12%',
      Middle: '28%',
      High: '59%',
      'Other/Prefer not to answer': '1%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '22%',
      'Mobile Players': '78%',
    },
    online_population: '28.9M',
    name: 'Malaysia',
    'Age Combined': {
      '10-20': '31%',
      '21-35': '38%',
      '36-50': '31%',
      '51-65': '0%',
    },
    gdp_normal_precent: '8.21%',
    total_population: '32.8M',
    total_population_precent: '1.22%',
    'Total Players': {
      'Total Players': '80%',
      'Non Total Players': '20%',
    },
    'Work situation': {
      'Full-time employee': '63%',
      'Part-time employee': '5%',
      'Self-employed or independent': '12%',
      'Full-time homemaker': '4%',
      Student: '11%',
      Unemployed: '4%',
      Retired: '1%',
      'Extended or currently furloughed': '0%',
    },
    Players: {
      'Total Players': '80%',
      'Non Total Players': '20%',
      'Mobile Players': '78%',
      'Non Mobile Players': '22%',
      'PC Players': '65%',
      'Non PC Players': '35%',
      'Console Players': '55%',
      'Non Console Players': '45%',
    },
  },
  es: {
    'Console Players': {
      'Console Players': '63%',
      'Non Console Players': '37%',
    },
    gdp_capita_precent: '5.64%',
    'Esports Audience': {
      'Esports Enthusiasts': '10%',
      'Occasional Viewers': '13%',
      'Non-Esports Audience': '77%',
    },
    Persona: {
      'The Ultimate Gamer': '5%',
      'The All-Round Enthusiast': '7%',
      'The Bargain Buyer': '17%',
      'The Community Gamer': '9%',
      'The Hardware Enthusiast': '6%',
      'The Popcorn Gamer': '8%',
      'The Backseat Viewer': '2%',
      'The Time Filler': '23%',
      'The Lapsed Gamer': '15%',
      'Not a Persona': '8%',
    },
    gdp_capita: '41.5K',
    Income: {
      Low: '46%',
      Middle: '30%',
      High: '19%',
      'Not Stated': '5%',
    },
    'PC Players': {
      'Non PC Players': '41%',
      'PC Players': '59%',
    },
    Gender: {
      Male: '50%',
      Female: '50%',
    },
    online_population_precent: '0.99%',
    gdp_normal: '1.46T',
    Education: {
      Low: '3%',
      Middle: '27%',
      High: '70%',
      'Other/Prefer not to answer': '0%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '31%',
      'Mobile Players': '69%',
    },
    online_population: '42.3M',
    name: 'Spain',
    'Age Combined': {
      '10-20': '15%',
      '21-35': '26%',
      '36-50': '35%',
      '51-65': '25%',
    },
    gdp_normal_precent: '6.08%',
    total_population: '46.7M',
    total_population_precent: '-0.07%',
    'Total Players': {
      'Total Players': '75%',
      'Non Total Players': '25%',
    },
    'Work situation': {
      'Full-time employee': '59%',
      'Part-time employee': '10%',
      'Self-employed or independent': '6%',
      'Full-time homemaker': '5%',
      Student: '7%',
      Unemployed: '10%',
      Retired: '3%',
      'Extended or currently furloughed': '0%',
    },
    Players: {
      'Total Players': '75%',
      'Non Total Players': '25%',
      'Mobile Players': '69%',
      'Non Mobile Players': '31%',
      'PC Players': '59%',
      'Non PC Players': '41%',
      'Console Players': '63%',
      'Non Console Players': '37%',
    },
  },
  ar: {
    'Console Players': {
      'Console Players': '59%',
      'Non Console Players': '41%',
    },
    gdp_capita_precent: '3.55%',
    'Esports Audience': {
      'Esports Enthusiasts': '13%',
      'Occasional Viewers': '15%',
      'Non-Esports Audience': '72%',
    },
    Persona: {
      'The Ultimate Gamer': '9%',
      'The All-Round Enthusiast': '7%',
      'The Bargain Buyer': '20%',
      'The Community Gamer': '6%',
      'The Hardware Enthusiast': '8%',
      'The Popcorn Gamer': '13%',
      'The Backseat Viewer': '2%',
      'The Time Filler': '20%',
      'The Lapsed Gamer': '12%',
      'Not a Persona': '4%',
    },
    gdp_capita: '22.1K',
    Income: {
      Low: '9%',
      Middle: '12%',
      High: '71%',
      'Not Stated': '8%',
    },
    'PC Players': {
      'Non PC Players': '30%',
      'PC Players': '70%',
    },
    Gender: {
      Male: '51%',
      Female: '49%',
    },
    online_population_precent: '2.36%',
    gdp_normal: '418B',
    Education: {
      Low: '10%',
      Middle: '46%',
      High: '44%',
      'Other/Prefer not to answer': '0%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '23%',
      'Mobile Players': '77%',
    },
    online_population: '37.7M',
    name: 'Argentina',
    'Age Combined': {
      '10-20': '30%',
      '21-35': '38%',
      '36-50': '23%',
      '51-65': '9%',
    },
    gdp_normal_precent: '4.19%',
    total_population: '45.6M',
    total_population_precent: '0.88%',
    'Total Players': {
      'Total Players': '82%',
      'Non Total Players': '18%',
    },
    'Work situation': {
      'Full-time employee': '49%',
      'Part-time employee': '16%',
      'Self-employed or independent': '13%',
      'Full-time homemaker': '3%',
      Student: '12%',
      Unemployed: '5%',
      Retired: '2%',
      'Extended or currently furloughed': '0%',
    },
    Players: {
      'Total Players': '82%',
      'Non Total Players': '18%',
      'Mobile Players': '77%',
      'Non Mobile Players': '23%',
      'PC Players': '70%',
      'Non PC Players': '30%',
      'Console Players': '59%',
      'Non Console Players': '41%',
    },
  },
  au: {
    'Console Players': {
      'Console Players': '45%',
      'Non Console Players': '55%',
    },
    gdp_capita_precent: '5.19%',
    'Esports Audience': {
      'Esports Enthusiasts': '5%',
      'Occasional Viewers': '6%',
      'Non-Esports Audience': '89%',
    },
    Persona: {
      'The Ultimate Gamer': '4%',
      'The All-Round Enthusiast': '5%',
      'The Bargain Buyer': '9%',
      'The Community Gamer': '7%',
      'The Hardware Enthusiast': '7%',
      'The Popcorn Gamer': '5%',
      'The Backseat Viewer': '3%',
      'The Time Filler': '20%',
      'The Lapsed Gamer': '21%',
      'Not a Persona': '17%',
    },
    gdp_capita: '55.5K',
    Income: {
      Low: '37%',
      Middle: '26%',
      High: '31%',
      'Not Stated': '6%',
    },
    'PC Players': {
      'Non PC Players': '57%',
      'PC Players': '43%',
    },
    Gender: {
      Male: '50%',
      Female: '50%',
    },
    online_population_precent: '1.81%',
    gdp_normal: '1.61T',
    Education: {
      Low: '13%',
      Middle: '35%',
      High: '52%',
      'Other/Prefer not to answer': '1%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '49%',
      'Mobile Players': '51%',
    },
    online_population: '23.4M',
    name: 'Australia',
    'Age Combined': {
      '10-20': '21%',
      '21-35': '28%',
      '36-50': '30%',
      '51-65': '21%',
    },
    gdp_normal_precent: '4.89%',
    total_population: '25.8M',
    total_population_precent: '1.07%',
    'Total Players': {
      'Total Players': '59%',
      'Non Total Players': '41%',
    },
    'Work situation': {
      'Full-time employee': '42%',
      'Part-time employee': '19%',
      'Self-employed or independent': '4%',
      'Full-time homemaker': '9%',
      Student: '7%',
      Unemployed: '11%',
      Retired: '8%',
      'Extended or currently furloughed': '0%',
    },
    Players: {
      'Total Players': '59%',
      'Non Total Players': '41%',
      'Mobile Players': '51%',
      'Non Mobile Players': '49%',
      'PC Players': '43%',
      'Non PC Players': '57%',
      'Console Players': '45%',
      'Non Console Players': '55%',
    },
  },
  th: {
    'Console Players': {
      'Console Players': '65%',
      'Non Console Players': '35%',
    },
    gdp_capita_precent: '6.90%',
    'Esports Audience': {
      'Esports Enthusiasts': '26%',
      'Occasional Viewers': '15%',
      'Non-Esports Audience': '59%',
    },
    Persona: {
      'The Ultimate Gamer': '9%',
      'The All-Round Enthusiast': '7%',
      'The Bargain Buyer': '25%',
      'The Community Gamer': '8%',
      'The Hardware Enthusiast': '6%',
      'The Popcorn Gamer': '20%',
      'The Backseat Viewer': '4%',
      'The Time Filler': '10%',
      'The Lapsed Gamer': '4%',
      'Not a Persona': '6%',
    },
    gdp_capita: '19.0K',
    Income: {
      Low: '11%',
      Middle: '38%',
      High: '48%',
      'Not Stated': '2%',
    },
    'PC Players': {
      'Non PC Players': '24%',
      'PC Players': '76%',
    },
    Gender: {
      Male: '50%',
      Female: '50%',
    },
    online_population_precent: '5.05%',
    gdp_normal: '539B',
    Education: {
      Low: '13%',
      Middle: '17%',
      High: '69%',
      'Other/Prefer not to answer': '1%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '16%',
      'Mobile Players': '84%',
    },
    online_population: '50.3M',
    name: 'Thailand',
    'Age Combined': {
      '10-20': '31%',
      '21-35': '44%',
      '36-50': '25%',
      '51-65': '0%',
    },
    gdp_normal_precent: '6.24%',
    total_population: '70.0M',
    total_population_precent: '0.17%',
    'Total Players': {
      'Total Players': '86%',
      'Non Total Players': '14%',
    },
    'Work situation': {
      'Full-time employee': '59%',
      'Part-time employee': '3%',
      'Self-employed or independent': '20%',
      'Full-time homemaker': '1%',
      Student: '12%',
      Unemployed: '5%',
      Retired: '0%',
      'Extended or currently furloughed': '0%',
    },
    Players: {
      'Total Players': '86%',
      'Non Total Players': '14%',
      'Mobile Players': '84%',
      'Non Mobile Players': '16%',
      'PC Players': '76%',
      'Non PC Players': '24%',
      'Console Players': '65%',
      'Non Console Players': '35%',
    },
  },
  ph: {
    'Console Players': {
      'Console Players': '56%',
      'Non Console Players': '44%',
    },
    gdp_capita_precent: '7.28%',
    'Esports Audience': {
      'Esports Enthusiasts': '26%',
      'Occasional Viewers': '20%',
      'Non-Esports Audience': '54%',
    },
    Persona: {
      'The Ultimate Gamer': '8%',
      'The All-Round Enthusiast': '5%',
      'The Bargain Buyer': '25%',
      'The Community Gamer': '7%',
      'The Hardware Enthusiast': '8%',
      'The Popcorn Gamer': '23%',
      'The Backseat Viewer': '3%',
      'The Time Filler': '13%',
      'The Lapsed Gamer': '5%',
      'Not a Persona': '3%',
    },
    gdp_capita: '9.06K',
    Income: {
      Low: '12%',
      Middle: '23%',
      High: '59%',
      'Not Stated': '6%',
    },
    'PC Players': {
      'Non PC Players': '23%',
      'PC Players': '77%',
    },
    Gender: {
      Male: '51%',
      Female: '49%',
    },
    online_population_precent: '4.59%',
    gdp_normal: '403B',
    Education: {
      Low: '1%',
      Middle: '23%',
      High: '76%',
      'Other/Prefer not to answer': '1%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '12%',
      'Mobile Players': '88%',
    },
    online_population: '78.9M',
    name: 'Philippines',
    'Age Combined': {
      '10-20': '37%',
      '21-35': '42%',
      '36-50': '21%',
      '51-65': '0%',
    },
    gdp_normal_precent: '7.96%',
    total_population: '111M',
    total_population_precent: '1.30%',
    'Total Players': {
      'Total Players': '89%',
      'Non Total Players': '11%',
    },
    'Work situation': {
      'Full-time employee': '51%',
      'Part-time employee': '9%',
      'Self-employed or independent': '16%',
      'Full-time homemaker': '2%',
      Student: '13%',
      Unemployed: '8%',
      Retired: '0%',
      'Extended or currently furloughed': '0%',
    },
    Players: {
      'Total Players': '89%',
      'Non Total Players': '11%',
      'Mobile Players': '88%',
      'Non Mobile Players': '12%',
      'PC Players': '77%',
      'Non PC Players': '23%',
      'Console Players': '56%',
      'Non Console Players': '44%',
    },
  },
  vn: {
    'Console Players': {
      'Console Players': '66%',
      'Non Console Players': '34%',
    },
    gdp_capita_precent: '8.52%',
    'Esports Audience': {
      'Esports Enthusiasts': '36%',
      'Occasional Viewers': '18%',
      'Non-Esports Audience': '46%',
    },
    Persona: {
      'The Ultimate Gamer': '9%',
      'The All-Round Enthusiast': '12%',
      'The Bargain Buyer': '24%',
      'The Community Gamer': '7%',
      'The Hardware Enthusiast': '7%',
      'The Popcorn Gamer': '22%',
      'The Backseat Viewer': '3%',
      'The Time Filler': '7%',
      'The Lapsed Gamer': '5%',
      'Not a Persona': '4%',
    },
    gdp_capita: '11.7K',
    Income: {
      Low: '7%',
      Middle: '20%',
      High: '72%',
      'Not Stated': '1%',
    },
    'PC Players': {
      'Non PC Players': '18%',
      'PC Players': '82%',
    },
    Gender: {
      Male: '51%',
      Female: '49%',
    },
    online_population_precent: '3.31%',
    gdp_normal: '355B',
    Education: {
      Low: '0%',
      Middle: '16%',
      High: '83%',
      'Other/Prefer not to answer': '1%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '13%',
      'Mobile Players': '87%',
    },
    online_population: '75.2M',
    name: 'Vietnam',
    'Age Combined': {
      '10-20': '28%',
      '21-35': '50%',
      '36-50': '22%',
      '51-65': '0%',
    },
    gdp_normal_precent: '9.84%',
    total_population: '98.2M',
    total_population_precent: '0.78%',
    'Total Players': {
      'Total Players': '88%',
      'Non Total Players': '12%',
    },
    'Work situation': {
      'Full-time employee': '70%',
      'Part-time employee': '5%',
      'Self-employed or independent': '9%',
      'Full-time homemaker': '1%',
      Student: '15%',
      Unemployed: '1%',
      Retired: '0%',
      'Extended or currently furloughed': '0%',
    },
    Players: {
      'Total Players': '88%',
      'Non Total Players': '12%',
      'Mobile Players': '87%',
      'Non Mobile Players': '13%',
      'PC Players': '82%',
      'Non PC Players': '18%',
      'Console Players': '66%',
      'Non Console Players': '34%',
    },
  },
  pl: {
    'Console Players': {
      'Console Players': '41%',
      'Non Console Players': '59%',
    },
    gdp_capita_precent: '6.74%',
    'Esports Audience': {
      'Esports Enthusiasts': '10%',
      'Occasional Viewers': '12%',
      'Non-Esports Audience': '78%',
    },
    Persona: {
      'The Ultimate Gamer': '4%',
      'The All-Round Enthusiast': '4%',
      'The Bargain Buyer': '10%',
      'The Community Gamer': '7%',
      'The Hardware Enthusiast': '6%',
      'The Popcorn Gamer': '15%',
      'The Backseat Viewer': '2%',
      'The Time Filler': '24%',
      'The Lapsed Gamer': '18%',
      'Not a Persona': '10%',
    },
    gdp_capita: '36.0K',
    Income: {
      Low: '34%',
      Middle: '47%',
      High: '11%',
      'Not Stated': '9%',
    },
    'PC Players': {
      'Non PC Players': '37%',
      'PC Players': '63%',
    },
    Gender: {
      Male: '50%',
      Female: '50%',
    },
    online_population_precent: '1.52%',
    gdp_normal: '642B',
    Education: {
      Low: '18%',
      Middle: '36%',
      High: '46%',
      'Other/Prefer not to answer': '0%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '36%',
      'Mobile Players': '64%',
    },
    online_population: '32.2M',
    name: 'Poland',
    'Age Combined': {
      '10-20': '19%',
      '21-35': '35%',
      '36-50': '27%',
      '51-65': '20%',
    },
    gdp_normal_precent: '8.28%',
    total_population: '37.8M',
    total_population_precent: '-0.16%',
    'Total Players': {
      'Total Players': '70%',
      'Non Total Players': '30%',
    },
    'Work situation': {
      'Full-time employee': '60%',
      'Part-time employee': '8%',
      'Self-employed or independent': '6%',
      'Full-time homemaker': '5%',
      Student: '7%',
      Unemployed: '6%',
      Retired: '7%',
      'Extended or currently furloughed': '1%',
    },
    Players: {
      'Total Players': '70%',
      'Non Total Players': '30%',
      'Mobile Players': '64%',
      'Non Mobile Players': '36%',
      'PC Players': '63%',
      'Non PC Players': '37%',
      'Console Players': '41%',
      'Non Console Players': '59%',
    },
  },
  nl: {
    'Console Players': {
      'Console Players': '38%',
      'Non Console Players': '62%',
    },
    gdp_capita_precent: '4.42%',
    'Esports Audience': {
      'Esports Enthusiasts': '4%',
      'Occasional Viewers': '6%',
      'Non-Esports Audience': '90%',
    },
    Persona: {
      'The Ultimate Gamer': '3%',
      'The All-Round Enthusiast': '4%',
      'The Bargain Buyer': '6%',
      'The Community Gamer': '9%',
      'The Hardware Enthusiast': '5%',
      'The Popcorn Gamer': '4%',
      'The Backseat Viewer': '2%',
      'The Time Filler': '27%',
      'The Lapsed Gamer': '20%',
      'Not a Persona': '20%',
    },
    gdp_capita: '60.5K',
    Income: {
      Low: '40%',
      Middle: '27%',
      High: '14%',
      'Not Stated': '18%',
    },
    'PC Players': {
      'Non PC Players': '63%',
      'PC Players': '37%',
    },
    Gender: {
      Male: '50%',
      Female: '50%',
    },
    online_population_precent: '0.67%',
    gdp_normal: '1.01T',
    Education: {
      Low: '22%',
      Middle: '32%',
      High: '46%',
      'Other/Prefer not to answer': '0%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '49%',
      'Mobile Players': '51%',
    },
    online_population: '16.5M',
    name: 'Netherlands',
    'Age Combined': {
      '10-20': '18%',
      '21-35': '25%',
      '36-50': '31%',
      '51-65': '27%',
    },
    gdp_normal_precent: '4.84%',
    total_population: '17.2M',
    total_population_precent: '0.22%',
    'Total Players': {
      'Total Players': '58%',
      'Non Total Players': '42%',
    },
    'Work situation': {
      'Full-time employee': '42%',
      'Part-time employee': '20%',
      'Self-employed or independent': '6%',
      'Full-time homemaker': '7%',
      Student: '9%',
      Unemployed: '11%',
      Retired: '3%',
      'Extended or currently furloughed': '1%',
    },
    Players: {
      'Total Players': '58%',
      'Non Total Players': '42%',
      'Mobile Players': '51%',
      'Non Mobile Players': '49%',
      'PC Players': '37%',
      'Non PC Players': '63%',
      'Console Players': '38%',
      'Non Console Players': '62%',
    },
  },
  tr: {
    'Console Players': {
      'Console Players': '70%',
      'Non Console Players': '30%',
    },
    gdp_capita_precent: '4.62%',
    'Esports Audience': {
      'Esports Enthusiasts': '25%',
      'Occasional Viewers': '16%',
      'Non-Esports Audience': '59%',
    },
    Persona: {
      'The Ultimate Gamer': '9%',
      'The All-Round Enthusiast': '8%',
      'The Bargain Buyer': '25%',
      'The Community Gamer': '7%',
      'The Hardware Enthusiast': '8%',
      'The Popcorn Gamer': '16%',
      'The Backseat Viewer': '8%',
      'The Time Filler': '9%',
      'The Lapsed Gamer': '6%',
      'Not a Persona': '5%',
    },
    gdp_capita: '32.3K',
    Income: {
      Low: '4%',
      Middle: '17%',
      High: '78%',
      'Not Stated': '2%',
    },
    'PC Players': {
      'Non PC Players': '24%',
      'PC Players': '76%',
    },
    Gender: {
      Male: '51%',
      Female: '49%',
    },
    online_population_precent: '3.59%',
    gdp_normal: '795B',
    Education: {
      Low: '7%',
      Middle: '26%',
      High: '67%',
      'Other/Prefer not to answer': '1%',
    },
    'Online Population': {
      '': '100%',
    },
    'Mobile Players': {
      'Non Mobile Players': '20%',
      'Mobile Players': '80%',
    },
    online_population: '66.6M',
    name: 'Turkey',
    'Age Combined': {
      '10-20': '28%',
      '21-35': '42%',
      '36-50': '30%',
      '51-65': '0%',
    },
    gdp_normal_precent: '9.58%',
    total_population: '85.0M',
    total_population_precent: '0.54%',
    'Total Players': {
      'Total Players': '82%',
      'Non Total Players': '18%',
    },
    'Work situation': {
      'Full-time employee': '63%',
      'Part-time employee': '6%',
      'Self-employed or independent': '4%',
      'Full-time homemaker': '8%',
      Student: '13%',
      Unemployed: '6%',
      Retired: '1%',
      'Extended or currently furloughed': '0%',
    },
    Players: {
      'Total Players': '82%',
      'Non Total Players': '18%',
      'Mobile Players': '80%',
      'Non Mobile Players': '20%',
      'PC Players': '76%',
      'Non PC Players': '24%',
      'Console Players': '70%',
      'Non Console Players': '30%',
    },
  },
    },
    '2022':{
        "de": {
            "Esports Audience": {
                "Esports Enthusiasts": "3.44%",
                "Occasional Viewers": "6.53%",
                "Non-Esports Audience": "90.03%"
            },
            "gdp_capita_precent": "3.79%",
            "Persona": {
                "The Ultimate Gamer": "4.57%",
                "The All-Round Enthusiast": "3.66%",
                "The Mainstream Gamer": "18.54%",
                "The Community Gamer": "5.31%",
                "The Solo Gamer": "3.03%",
                "The Popcorn Gamer": "11.24%",
                "The Backseat Viewer": "1.03%",
                "The Time Filler": "24.81%",
                "The Lapsed Gamer": "12.25%",
                "Not a Persona": "15.56%"
            },
            "gdp_capita": "62.4K",
            "Income": {
                "Low": "28.46%",
                "Middle": "33.69%",
                "High": "30.66%",
                "Other/Prefer not to answer": "7.19%"
            },
            "Gender": {
                "Male": "50.78%",
                "Female": "48.98%",
                "Other": "0.25%"
            },
            "online_population_precent": "0.67%",
            "gdp_normal": "4.56T",
            "Education": {
                "Low": "7.82%",
                "Middle": "65.45%",
                "High": "26.25%",
                "Other/Prefer not to answer": "0.47%"
            },
            "name": "Germany",
            "online_population": "77.5M",
            "Age Combined": {
                "10-20": "15.09%",
                "21-35": "25.48%",
                "36-50": "27.48%",
                "51-65": "31.95%"
            },
            "gdp_normal_precent": "4.60%",
            "total_population": "83.9M",
            "total_population_precent": "-0.15%",
            "Work situation": {
                "Full-time employee": "51.97%",
                "Part-time employee": "14.21%",
                "Self-employed or independent": "4.73%",
                "Full-time homemaker": "5.00%",
                "Student": "6.00%",
                "Unemployed": "4.54%",
                "Retired": "9.01%",
                "Other": "4.54%"
            },
            "Players": {
                "Total Players": "28.84%",
                "Non Total Players": "71.16%",
                "Mobile Players": "57.13%",
                "Non Mobile Players": "42.87%",
                "PC Players": "66.07%",
                "Non PC Players": "33.93%",
                "Console Players": "34.32%",
                "Non Console Players": "65.68%"
            }
        },
        "be": {
            "Esports Audience": {
                "Esports Enthusiasts": "2.02%",
                "Occasional Viewers": "5.36%",
                "Non-Esports Audience": "92.62%"
            },
            "gdp_capita_precent": "3.49%",
            "Persona": {
                "The Ultimate Gamer": "3.75%",
                "The All-Round Enthusiast": "4.13%",
                "The Mainstream Gamer": "17.99%",
                "The Community Gamer": "4.36%",
                "The Solo Gamer": "2.01%",
                "The Popcorn Gamer": "7.73%",
                "The Backseat Viewer": "1.24%",
                "The Time Filler": "21.24%",
                "The Lapsed Gamer": "15.74%",
                "Not a Persona": "21.82%"
            },
            "gdp_capita": "59.0K",
            "Income": {
                "Low": "25.51%",
                "Middle": "24.98%",
                "High": "26.15%",
                "Other/Prefer not to answer": "23.36%"
            },
            "Gender": {
                "Male": "50.64%",
                "Female": "48.98%",
                "Other": "0.38%"
            },
            "online_population_precent": "0.94%",
            "gdp_normal": "619B",
            "Education": {
                "Low": "14.02%",
                "Middle": "55.13%",
                "High": "30.64%",
                "Other/Prefer not to answer": "0.21%"
            },
            "name": "Belgium",
            "online_population": "10.9M",
            "Age Combined": {
                "10-20": "17.99%",
                "21-35": "26.09%",
                "36-50": "27.86%",
                "51-65": "28.06%"
            },
            "gdp_normal_precent": "4.80%",
            "total_population": "11.7M",
            "total_population_precent": "0.26%",
            "Work situation": {
                "Full-time employee": "45.85%",
                "Part-time employee": "11.60%",
                "Self-employed or independent": "2.37%",
                "Full-time homemaker": "5.26%",
                "Student": "11.55%",
                "Unemployed": "7.16%",
                "Retired": "9.82%",
                "Other": "6.39%"
            },
            "Players": {
                "Total Players": "38.79%",
                "Non Total Players": "61.21%",
                "Mobile Players": "62.54%",
                "Non Mobile Players": "37.46%",
                "PC Players": "74.24%",
                "Non PC Players": "25.76%",
                "Console Players": "29.30%",
                "Non Console Players": "70.70%"
            }
        },
        "fi": {
            "Esports Audience": {
                "Esports Enthusiasts": "4.74%",
                "Occasional Viewers": "9.42%",
                "Non-Esports Audience": "85.84%"
            },
            "gdp_capita_precent": "3.76%",
            "Persona": {
                "The Ultimate Gamer": "4.26%",
                "The All-Round Enthusiast": "4.01%",
                "The Mainstream Gamer": "19.80%",
                "The Community Gamer": "2.78%",
                "The Solo Gamer": "2.17%",
                "The Popcorn Gamer": "12.07%",
                "The Backseat Viewer": "0.85%",
                "The Time Filler": "23.56%",
                "The Lapsed Gamer": "21.24%",
                "Not a Persona": "9.27%"
            },
            "gdp_capita": "56.1K",
            "Income": {
                "Low": "33.64%",
                "Middle": "30.26%",
                "High": "25.57%",
                "Other/Prefer not to answer": "10.54%"
            },
            "Gender": {
                "Male": "50.47%",
                "Female": "48.91%",
                "Other": "0.62%"
            },
            "online_population_precent": "0.93%",
            "gdp_normal": "315B",
            "Education": {
                "Low": "16.96%",
                "Middle": "54.05%",
                "High": "28.57%",
                "Other/Prefer not to answer": "0.42%"
            },
            "name": "Finland",
            "online_population": "5.19M",
            "Age Combined": {
                "10-20": "17.95%",
                "21-35": "26.99%",
                "36-50": "27.15%",
                "51-65": "27.91%"
            },
            "gdp_normal_precent": "4.83%",
            "total_population": "5.55M",
            "total_population_precent": "0.09%",
            "Work situation": {
                "Full-time employee": "39.95%",
                "Part-time employee": "11.29%",
                "Self-employed or independent": "4.82%",
                "Full-time homemaker": "1.54%",
                "Student": "13.13%",
                "Unemployed": "13.40%",
                "Retired": "9.48%",
                "Other": "6.38%"
            },
            "Players": {
                "Total Players": "31.36%",
                "Non Total Players": "68.64%",
                "Mobile Players": "54.01%",
                "Non Mobile Players": "45.99%",
                "PC Players": "65.60%",
                "Non PC Players": "34.40%",
                "Console Players": "34.19%",
                "Non Console Players": "65.81%"
            }
        },
        "ru": {
            "Esports Audience": {
                "Esports Enthusiasts": "4.22%",
                "Occasional Viewers": "10.53%",
                "Non-Esports Audience": "85.26%"
            },
            "gdp_capita_precent": "-",
            "Persona": {
                "The Ultimate Gamer": "5.26%",
                "The All-Round Enthusiast": "5.12%",
                "The Mainstream Gamer": "19.90%",
                "The Community Gamer": "5.71%",
                "The Solo Gamer": "3.83%",
                "The Popcorn Gamer": "12.40%",
                "The Backseat Viewer": "1.42%",
                "The Time Filler": "27.23%",
                "The Lapsed Gamer": "14.11%",
                "Not a Persona": "5.03%"
            },
            "gdp_capita": "-",
            "Income": {
                "Low": "9.12%",
                "Middle": "20.58%",
                "High": "65.35%",
                "Other/Prefer not to answer": "4.95%"
            },
            "Gender": {
                "Male": "51.59%",
                "Female": "48.11%",
                "Other": "0.30%"
            },
            "online_population_precent": "-",
            "gdp_normal": "-",
            "Education": {
                "Low": "7.88%",
                "Middle": "39.36%",
                "High": "52.64%",
                "Other/Prefer not to answer": "0.12%"
            },
            "name": "Russia",
            "online_population": "-",
            "Age Combined": {
                "10-20": "19.15%",
                "21-35": "37.96%",
                "36-50": "28.08%",
                "51-65": "14.82%"
            },
            "gdp_normal_precent": "-",
            "total_population": "-",
            "total_population_precent": "-",
            "Work situation": {
                "Full-time employee": "59.31%",
                "Part-time employee": "8.01%",
                "Self-employed or independent": "3.53%",
                "Full-time homemaker": "4.88%",
                "Student": "8.77%",
                "Unemployed": "6.51%",
                "Retired": "4.43%",
                "Other": "4.57%"
            },
            "Players": {
                "Total Players": "20.56%",
                "Non Total Players": "79.44%",
                "Mobile Players": "38.98%",
                "Non Mobile Players": "61.02%",
                "PC Players": "47.52%",
                "Non PC Players": "52.48%",
                "Console Players": "23.02%",
                "Non Console Players": "76.98%"
            }
        },
        "tw": {
            "Esports Audience": {
                "Esports Enthusiasts": "11.94%",
                "Occasional Viewers": "13.74%",
                "Non-Esports Audience": "74.32%"
            },
            "gdp_capita_precent": "5.00%",
            "Persona": {
                "The Ultimate Gamer": "4.09%",
                "The All-Round Enthusiast": "3.56%",
                "The Mainstream Gamer": "21.49%",
                "The Community Gamer": "5.93%",
                "The Solo Gamer": "5.57%",
                "The Popcorn Gamer": "24.28%",
                "The Backseat Viewer": "1.48%",
                "The Time Filler": "22.24%",
                "The Lapsed Gamer": "5.34%",
                "Not a Persona": "6.03%"
            },
            "gdp_capita": "65.3K",
            "Income": {
                "Low": "33.59%",
                "Middle": "35.46%",
                "High": "24.42%",
                "Other/Prefer not to answer": "6.52%"
            },
            "Gender": {
                "Male": "50.61%",
                "Female": "49.16%",
                "Other": "0.24%"
            },
            "online_population_precent": "1.64%",
            "gdp_normal": "851B",
            "Education": {
                "Low": "0.72%",
                "Middle": "30.46%",
                "High": "67.81%",
                "Other/Prefer not to answer": "1.00%"
            },
            "name": "Taiwan",
            "online_population": "21.6M",
            "Age Combined": {
                "10-20": "18.53%",
                "21-35": "36.83%",
                "36-50": "44.64%",
                "51-65": "0.00%"
            },
            "gdp_normal_precent": "5.87%",
            "total_population": "23.9M",
            "total_population_precent": "0.11%",
            "Work situation": {
                "Full-time employee": "70.35%",
                "Part-time employee": "4.43%",
                "Self-employed or independent": "7.16%",
                "Full-time homemaker": "2.95%",
                "Student": "11.48%",
                "Unemployed": "3.04%",
                "Retired": "0.05%",
                "Other": "0.53%"
            },
            "Players": {
                "Total Players": "12.85%",
                "Non Total Players": "87.15%",
                "Mobile Players": "25.01%",
                "Non Mobile Players": "74.99%",
                "PC Players": "53.59%",
                "Non PC Players": "46.41%",
                "Console Players": "37.35%",
                "Non Console Players": "62.65%"
            }
        },
        "jp": {
            "Esports Audience": {
                "Esports Enthusiasts": "7.32%",
                "Occasional Viewers": "8.46%",
                "Non-Esports Audience": "84.23%"
            },
            "gdp_capita_precent": "3.92%",
            "Persona": {
                "The Ultimate Gamer": "5.60%",
                "The All-Round Enthusiast": "4.40%",
                "The Mainstream Gamer": "16.34%",
                "The Community Gamer": "4.55%",
                "The Solo Gamer": "2.50%",
                "The Popcorn Gamer": "10.91%",
                "The Backseat Viewer": "1.79%",
                "The Time Filler": "23.22%",
                "The Lapsed Gamer": "14.06%",
                "Not a Persona": "16.62%"
            },
            "gdp_capita": "47.8K",
            "Income": {
                "Low": "25.25%",
                "Middle": "34.70%",
                "High": "28.14%",
                "Other/Prefer not to answer": "11.91%"
            },
            "Gender": {
                "Male": "50.68%",
                "Female": "49.07%",
                "Other": "0.24%"
            },
            "online_population_precent": "0.37%",
            "gdp_normal": "5.38T",
            "Education": {
                "Low": "3.09%",
                "Middle": "28.66%",
                "High": "64.88%",
                "Other/Prefer not to answer": "3.38%"
            },
            "name": "Japan",
            "online_population": "116M",
            "Age Combined": {
                "10-20": "15.43%",
                "21-35": "23.43%",
                "36-50": "31.66%",
                "51-65": "29.48%"
            },
            "gdp_normal_precent": "5.20%",
            "total_population": "126M",
            "total_population_precent": "-0.42%",
            "Work situation": {
                "Full-time employee": "43.14%",
                "Part-time employee": "10.39%",
                "Self-employed or independent": "9.58%",
                "Full-time homemaker": "11.75%",
                "Student": "8.21%",
                "Unemployed": "8.39%",
                "Retired": "1.48%",
                "Other": "7.06%"
            },
            "Players": {
                "Total Players": "32.47%",
                "Non Total Players": "67.53%",
                "Mobile Players": "47.02%",
                "Non Mobile Players": "52.98%",
                "PC Players": "74.73%",
                "Non PC Players": "25.27%",
                "Console Players": "37.00%",
                "Non Console Players": "63.00%"
            }
        },
        "fr": {
            "Esports Audience": {
                "Esports Enthusiasts": "5.27%",
                "Occasional Viewers": "8.35%",
                "Non-Esports Audience": "86.37%"
            },
            "gdp_capita_precent": "3.73%",
            "Persona": {
                "The Ultimate Gamer": "4.18%",
                "The All-Round Enthusiast": "4.44%",
                "The Mainstream Gamer": "19.27%",
                "The Community Gamer": "4.65%",
                "The Solo Gamer": "2.98%",
                "The Popcorn Gamer": "10.17%",
                "The Backseat Viewer": "1.01%",
                "The Time Filler": "24.70%",
                "The Lapsed Gamer": "12.87%",
                "Not a Persona": "15.72%"
            },
            "gdp_capita": "54.2K",
            "Income": {
                "Low": "38.07%",
                "Middle": "30.55%",
                "High": "24.22%",
                "Other/Prefer not to answer": "7.16%"
            },
            "Gender": {
                "Male": "49.56%",
                "Female": "50.30%",
                "Other": "0.14%"
            },
            "online_population_precent": "1.12%",
            "gdp_normal": "3.14T",
            "Education": {
                "Low": "13.04%",
                "Middle": "34.63%",
                "High": "51.35%",
                "Other/Prefer not to answer": "0.97%"
            },
            "name": "France",
            "online_population": "60,3M",
            "Age Combined": {
                "10-20": "19.59%",
                "21-35": "25.58%",
                "36-50": "27.79%",
                "51-65": "27.03%"
            },
            "gdp_normal_precent": "4.30%",
            "total_population": "65.6M",
            "total_population_precent": "0.24%",
            "Work situation": {
                "Full-time employee": "57.10%",
                "Part-time employee": "7.41%",
                "Self-employed or independent": "4.21%",
                "Full-time homemaker": "5.36%",
                "Student": "9.78%",
                "Unemployed": "6.69%",
                "Retired": "8.17%",
                "Other": "1.28%"
            },
            "Players": {
                "Total Players": "29.60%",
                "Non Total Players": "70.40%",
                "Mobile Players": "55.66%",
                "Non Mobile Players": "44.34%",
                "PC Players": "70.12%",
                "Non PC Players": "29.88%",
                "Console Players": "40.78%",
                "Non Console Players": "59.22%"
            }
        },
        "nz": {
            "Esports Audience": {
                "Esports Enthusiasts": "4.38%",
                "Occasional Viewers": "6.93%",
                "Non-Esports Audience": "88.69%"
            },
            "gdp_capita_precent": "2.65%",
            "Persona": {
                "The Ultimate Gamer": "3.52%",
                "The All-Round Enthusiast": "4.54%",
                "The Mainstream Gamer": "19.93%",
                "The Community Gamer": "4.87%",
                "The Solo Gamer": "2.44%",
                "The Popcorn Gamer": "9.03%",
                "The Backseat Viewer": "3.03%",
                "The Time Filler": "22.19%",
                "The Lapsed Gamer": "17.42%",
                "Not a Persona": "13.03%"
            },
            "gdp_capita": "48.2K",
            "Income": {
                "Low": "28.34%",
                "Middle": "31.03%",
                "High": "29.19%",
                "Other/Prefer not to answer": "11.45%"
            },
            "Gender": {
                "Male": "49.00%",
                "Female": "50.10%",
                "Other": "0.90%"
            },
            "online_population_precent": "1.18%",
            "gdp_normal": "268B",
            "Education": {
                "Low": "11.53%",
                "Middle": "29.72%",
                "High": "57.52%",
                "Other/Prefer not to answer": "1.23%"
            },
            "name": "New Zealand",
            "online_population": "4.59M",
            "Age Combined": {
                "10-20": "20.20%",
                "21-35": "29.23%",
                "36-50": "25.96%",
                "51-65": "24.61%"
            },
            "gdp_normal_precent": "4.90%",
            "total_population": "4.90M",
            "total_population_precent": "0.74%",
            "Work situation": {
                "Full-time employee": "53.17%",
                "Part-time employee": "14.42%",
                "Self-employed or independent": "4.45%",
                "Full-time homemaker": "5.73%",
                "Student": "7.59%",
                "Unemployed": "8.29%",
                "Retired": "3.93%",
                "Other": "2.42%"
            },
            "Players": {
                "Total Players": "33.48%",
                "Non Total Players": "66.52%",
                "Mobile Players": "55.95%",
                "Non Mobile Players": "44.05%",
                "PC Players": "72.69%",
                "Non PC Players": "27.31%",
                "Console Players": "31.14%",
                "Non Console Players": "68.86%"
            }
        },
        "sa": {
            "Esports Audience": {
                "Esports Enthusiasts": "7.25%",
                "Occasional Viewers": "13.62%",
                "Non-Esports Audience": "79.13%"
            },
            "gdp_capita_precent": "3.13%",
            "Persona": {
                "The Ultimate Gamer": "2.46%",
                "The All-Round Enthusiast": "3.16%",
                "The Mainstream Gamer": "16.72%",
                "The Community Gamer": "3.44%",
                "The Solo Gamer": "3.67%",
                "The Popcorn Gamer": "29.05%",
                "The Backseat Viewer": "4.69%",
                "The Time Filler": "17.25%",
                "The Lapsed Gamer": "12.11%",
                "Not a Persona": "7.45%"
            },
            "gdp_capita": "51.6K",
            "Income": {
                "Low": "37.64%",
                "Middle": "42.47%",
                "High": "7.94%",
                "Other/Prefer not to answer": "11.94%"
            },
            "Gender": {
                "Male": "58.25%",
                "Female": "41.75%",
                "Other": "0.00%"
            },
            "online_population_precent": "2.53%",
            "gdp_normal": "876B",
            "Education": {
                "Low": "27.92%",
                "Middle": "18.47%",
                "High": "52.19%",
                "Other/Prefer not to answer": "1.42%"
            },
            "name": "Saudi Arabia",
            "online_population": "33.3M",
            "Age Combined": {
                "10-20": "23.18%",
                "21-35": "39.56%",
                "36-50": "37.25%",
                "51-65": "0.00%"
            },
            "gdp_normal_precent": "2.96%",
            "total_population": "35.8M",
            "total_population_precent": "1.32%",
            "Work situation": {
                "Full-time employee": "54.30%",
                "Part-time employee": "7.76%",
                "Self-employed or independent": "5.73%",
                "Full-time homemaker": "14.22%",
                "Student": "9.62%",
                "Unemployed": "7.13%",
                "Retired": "1.24%",
                "Other": "0.00%"
            },
            "Players": {
                "Total Players": "24.26%",
                "Non Total Players": "75.74%",
                "Mobile Players": "39.61%",
                "Non Mobile Players": "60.39%",
                "PC Players": "81.16%",
                "Non PC Players": "18.84%",
                "Console Players": "26.41%",
                "Non Console Players": "73.59%"
            }
        },
        "br": {
            "Esports Audience": {
                "Esports Enthusiasts": "12.13%",
                "Occasional Viewers": "14.78%",
                "Non-Esports Audience": "73.08%"
            },
            "gdp_capita_precent": "3.85%",
            "Persona": {
                "The Ultimate Gamer": "3.65%",
                "The All-Round Enthusiast": "3.89%",
                "The Mainstream Gamer": "18.01%",
                "The Community Gamer": "2.89%",
                "The Solo Gamer": "3.33%",
                "The Popcorn Gamer": "24.23%",
                "The Backseat Viewer": "3.34%",
                "The Time Filler": "20.51%",
                "The Lapsed Gamer": "11.26%",
                "Not a Persona": "8.89%"
            },
            "gdp_capita": "16.8K",
            "Income": {
                "Low": "16.05%",
                "Middle": "42.41%",
                "High": "37.06%",
                "Other/Prefer not to answer": "4.48%"
            },
            "Gender": {
                "Male": "49.01%",
                "Female": "50.67%",
                "Other": "0.32%"
            },
            "online_population_precent": "3.01%",
            "gdp_normal": "1.81T",
            "Education": {
                "Low": "10.67%",
                "Middle": "40.89%",
                "High": "48.35%",
                "Other/Prefer not to answer": "0.09%"
            },
            "name": "Brazil",
            "online_population": "168M",
            "Age Combined": {
                "10-20": "23.36%",
                "21-35": "40.80%",
                "36-50": "25.03%",
                "51-65": "10.80%"
            },
            "gdp_normal_precent": "8.21%",
            "total_population": "215M",
            "total_population_precent": "0.58%",
            "Work situation": {
                "Full-time employee": "47.65%",
                "Part-time employee": "6.24%",
                "Self-employed or independent": "17.27%",
                "Full-time homemaker": "3.26%",
                "Student": "10.94%",
                "Unemployed": "9.62%",
                "Retired": "3.36%",
                "Other": "1.67%"
            },
            "Players": {
                "Total Players": "23.49%",
                "Non Total Players": "76.51%",
                "Mobile Players": "40.36%",
                "Non Mobile Players": "59.64%",
                "PC Players": "69.78%",
                "Non PC Players": "30.22%",
                "Console Players": "30.63%",
                "Non Console Players": "69.37%"
            }
        },
        "se": {
            "Esports Audience": {
                "Esports Enthusiasts": "4.74%",
                "Occasional Viewers": "8.09%",
                "Non-Esports Audience": "87.16%"
            },
            "gdp_capita_precent": "3.83%",
            "Persona": {
                "The Ultimate Gamer": "4.22%",
                "The All-Round Enthusiast": "4.18%",
                "The Mainstream Gamer": "19.53%",
                "The Community Gamer": "4.44%",
                "The Solo Gamer": "2.62%",
                "The Popcorn Gamer": "11.44%",
                "The Backseat Viewer": "2.01%",
                "The Time Filler": "24.68%",
                "The Lapsed Gamer": "15.95%",
                "Not a Persona": "10.92%"
            },
            "gdp_capita": "60.4K",
            "Income": {
                "Low": "29.56%",
                "Middle": "31.85%",
                "High": "25.77%",
                "Other/Prefer not to answer": "12.82%"
            },
            "Gender": {
                "Male": "50.66%",
                "Female": "48.83%",
                "Other": "0.50%"
            },
            "online_population_precent": "1.02%",
            "gdp_normal": "661B",
            "Education": {
                "Low": "8.87%",
                "Middle": "56.65%",
                "High": "33.85%",
                "Other/Prefer not to answer": "0.63%"
            },
            "name": "Sweden",
            "online_population": "9.60M",
            "Age Combined": {
                "10-20": "18.25%",
                "21-35": "28.16%",
                "36-50": "27.26%",
                "51-65": "26.32%"
            },
            "gdp_normal_precent": "6.36%",
            "total_population": "10.2M",
            "total_population_precent": "0.55%",
            "Work situation": {
                "Full-time employee": "48.38%",
                "Part-time employee": "11.25%",
                "Self-employed or independent": "4.58%",
                "Full-time homemaker": "2.09%",
                "Student": "11.85%",
                "Unemployed": "9.20%",
                "Retired": "7.91%",
                "Other": "4.74%"
            },
            "Players": {
                "Total Players": "28.88%",
                "Non Total Players": "71.12%",
                "Mobile Players": "48.27%",
                "Non Mobile Players": "51.73%",
                "PC Players": "68.16%",
                "Non PC Players": "31.84%",
                "Console Players": "35.20%",
                "Non Console Players": "64.80%"
            }
        },
        "sg": {
            "Esports Audience": {
                "Esports Enthusiasts": "6.77%",
                "Occasional Viewers": "12.63%",
                "Non-Esports Audience": "80.59%"
            },
            "gdp_capita_precent": "4.56%",
            "Persona": {
                "The Ultimate Gamer": "2.86%",
                "The All-Round Enthusiast": "5.73%",
                "The Mainstream Gamer": "22.72%",
                "The Community Gamer": "6.27%",
                "The Solo Gamer": "4.07%",
                "The Popcorn Gamer": "17.58%",
                "The Backseat Viewer": "6.40%",
                "The Time Filler": "20.66%",
                "The Lapsed Gamer": "7.37%",
                "Not a Persona": "6.34%"
            },
            "gdp_capita": "114K",
            "Income": {
                "Low": "30.98%",
                "Middle": "27.72%",
                "High": "37.47%",
                "Other/Prefer not to answer": "3.83%"
            },
            "Gender": {
                "Male": "52.07%",
                "Female": "46.52%",
                "Other": "1.40%"
            },
            "online_population_precent": "1.64%",
            "gdp_normal": "397B",
            "Education": {
                "Low": "3.92%",
                "Middle": "23.23%",
                "High": "72.13%",
                "Other/Prefer not to answer": "0.72%"
            },
            "name": "Singapore",
            "online_population": "5.50M",
            "Age Combined": {
                "10-20": "17.30%",
                "21-35": "38.82%",
                "36-50": "43.88%",
                "51-65": "0.00%"
            },
            "gdp_normal_precent": "5.29%",
            "total_population": "5.94M",
            "total_population_precent": "0.77%",
            "Work situation": {
                "Full-time employee": "76.23%",
                "Part-time employee": "5.55%",
                "Self-employed or independent": "5.33%",
                "Full-time homemaker": "2.51%",
                "Student": "7.78%",
                "Unemployed": "2.41%",
                "Retired": "0.19%",
                "Other": "0.00%"
            },
            "Players": {
                "Total Players": "20.11%",
                "Non Total Players": "79.89%",
                "Mobile Players": "39.83%",
                "Non Mobile Players": "60.17%",
                "PC Players": "66.14%",
                "Non PC Players": "33.86%",
                "Console Players": "27.87%",
                "Non Console Players": "72.13%"
            }
        },
        "id": {
            "Esports Audience": {
                "Esports Enthusiasts": "26.25%",
                "Occasional Viewers": "24.03%",
                "Non-Esports Audience": "49.72%"
            },
            "gdp_capita_precent": "7.44%",
            "Persona": {
                "The Ultimate Gamer": "2.79%",
                "The All-Round Enthusiast": "3.28%",
                "The Mainstream Gamer": "22.54%",
                "The Community Gamer": "5.69%",
                "The Solo Gamer": "3.69%",
                "The Popcorn Gamer": "42.39%",
                "The Backseat Viewer": "3.00%",
                "The Time Filler": "11.67%",
                "The Lapsed Gamer": "3.25%",
                "Not a Persona": "1.70%"
            },
            "gdp_capita": "14.0K",
            "Income": {
                "Low": "10.30%",
                "Middle": "25.05%",
                "High": "61.39%",
                "Other/Prefer not to answer": "3.26%"
            },
            "Gender": {
                "Male": "52.22%",
                "Female": "47.75%",
                "Other": "0.03%"
            },
            "online_population_precent": "4.65%",
            "gdp_normal": "1.25T",
            "Education": {
                "Low": "6.54%",
                "Middle": "44.42%",
                "High": "48.49%",
                "Other/Prefer not to answer": "0.55%"
            },
            "name": "Indonesia",
            "online_population": "219M",
            "Age Combined": {
                "10-20": "35.30%",
                "21-35": "43.40%",
                "36-50": "21.30%",
                "51-65": "0.00%"
            },
            "gdp_normal_precent": "8.09%",
            "total_population": "279M",
            "total_population_precent": "0.96%",
            "Work situation": {
                "Full-time employee": "40.68%",
                "Part-time employee": "14.47%",
                "Self-employed or independent": "18.98%",
                "Full-time homemaker": "5.02%",
                "Student": "16.63%",
                "Unemployed": "2.98%",
                "Retired": "1.24%",
                "Other": "0.00%"
            },
            "Players": {
                "Total Players": "7.95%",
                "Non Total Players": "92.05%",
                "Mobile Players": "15.80%",
                "Non Mobile Players": "84.20%",
                "PC Players": "65.33%",
                "Non PC Players": "34.67%",
                "Console Players": "23.18%",
                "Non Console Players": "76.82%"
            }
        },
        "gb": {
            "Esports Audience": {
                "Esports Enthusiasts": "6.27%",
                "Occasional Viewers": "8.66%",
                "Non-Esports Audience": "85.08%"
            },
            "gdp_capita_precent": "3.73%",
            "Persona": {
                "The Ultimate Gamer": "4.76%",
                "The All-Round Enthusiast": "5.48%",
                "The Mainstream Gamer": "17.49%",
                "The Community Gamer": "5.45%",
                "The Solo Gamer": "2.01%",
                "The Popcorn Gamer": "11.26%",
                "The Backseat Viewer": "0.94%",
                "The Time Filler": "24.42%",
                "The Lapsed Gamer": "11.39%",
                "Not a Persona": "16.79%"
            },
            "gdp_capita": "52.3K",
            "Income": {
                "Low": "33.25%",
                "Middle": "26.82%",
                "High": "31.38%",
                "Other/Prefer not to answer": "8.55%"
            },
            "Gender": {
                "Male": "49.82%",
                "Female": "49.78%",
                "Other": "0.39%"
            },
            "online_population_precent": "1.07%",
            "gdp_normal": "3.44T",
            "Education": {
                "Low": "4.38%",
                "Middle": "37.98%",
                "High": "56.74%",
                "Other/Prefer not to answer": "0.90%"
            },
            "name": "United Kingdom",
            "online_population": "63.8M",
            "Age Combined": {
                "10-20": "18.25%",
                "21-35": "27.66%",
                "36-50": "27.87%",
                "51-65": "26.22%"
            },
            "gdp_normal_precent": "4.54%",
            "total_population": "68.5M",
            "total_population_precent": "0.38%",
            "Work situation": {
                "Full-time employee": "51.22%",
                "Part-time employee": "12.64%",
                "Self-employed or independent": "4.94%",
                "Full-time homemaker": "6.74%",
                "Student": "7.19%",
                "Unemployed": "7.62%",
                "Retired": "7.49%",
                "Other": "2.16%"
            },
            "Players": {
                "Total Players": "29.13%",
                "Non Total Players": "70.87%",
                "Mobile Players": "54.13%",
                "Non Mobile Players": "45.87%",
                "PC Players": "70.62%",
                "Non PC Players": "29.38%",
                "Console Players": "41.18%",
                "Non Console Players": "58.82%"
            }
        },
        "ca": {
            "Esports Audience": {
                "Esports Enthusiasts": "3.61%",
                "Occasional Viewers": "5.04%",
                "Non-Esports Audience": "91.35%"
            },
            "gdp_capita_precent": "3.38%",
            "Persona": {
                "The Ultimate Gamer": "3.88%",
                "The All-Round Enthusiast": "3.52%",
                "The Mainstream Gamer": "16.90%",
                "The Community Gamer": "4.77%",
                "The Solo Gamer": "2.37%",
                "The Popcorn Gamer": "8.53%",
                "The Backseat Viewer": "1.36%",
                "The Time Filler": "26.71%",
                "The Lapsed Gamer": "17.27%",
                "Not a Persona": "14.70%"
            },
            "gdp_capita": "56.6K",
            "Income": {
                "Low": "32.93%",
                "Middle": "29.00%",
                "High": "29.89%",
                "Other/Prefer not to answer": "8.17%"
            },
            "Gender": {
                "Male": "50.06%",
                "Female": "49.30%",
                "Other": "0.64%"
            },
            "online_population_precent": "1.46%",
            "gdp_normal": "2.19T",
            "Education": {
                "Low": "3.44%",
                "Middle": "18.72%",
                "High": "77.12%",
                "Other/Prefer not to answer": "0.73%"
            },
            "name": "Canada",
            "online_population": "35.3M",
            "Age Combined": {
                "10-20": "16.59%",
                "21-35": "28.66%",
                "36-50": "27.91%",
                "51-65": "26.84%"
            },
            "gdp_normal_precent": "4.98%",
            "total_population": "38.4M",
            "total_population_precent": "0.82%",
            "Work situation": {
                "Full-time employee": "50.51%",
                "Part-time employee": "10.12%",
                "Self-employed or independent": "5.74%",
                "Full-time homemaker": "4.11%",
                "Student": "8.50%",
                "Unemployed": "7.95%",
                "Retired": "11.68%",
                "Other": "1.39%"
            },
            "Players": {
                "Total Players": "33.32%",
                "Non Total Players": "66.68%",
                "Mobile Players": "56.79%",
                "Non Mobile Players": "43.21%",
                "PC Players": "71.47%",
                "Non PC Players": "28.53%",
                "Console Players": "34.79%",
                "Non Console Players": "65.21%"
            }
        },
        "us": {
            "Esports Audience": {
                "Esports Enthusiasts": "9.12%",
                "Occasional Viewers": "9.19%",
                "Non-Esports Audience": "81.69%"
            },
            "gdp_capita_precent": "3.93%",
            "Persona": {
                "The Ultimate Gamer": "2.82%",
                "The All-Round Enthusiast": "3.44%",
                "The Mainstream Gamer": "18.52%",
                "The Community Gamer": "6.15%",
                "The Solo Gamer": "3.21%",
                "The Popcorn Gamer": "17.14%",
                "The Backseat Viewer": "1.14%",
                "The Time Filler": "19.44%",
                "The Lapsed Gamer": "12.67%",
                "Not a Persona": "15.48%"
            },
            "gdp_capita": "74.7K",
            "Income": {
                "Low": "30.50%",
                "Middle": "32.03%",
                "High": "29.78%",
                "Other/Prefer not to answer": "7.68%"
            },
            "Gender": {
                "Male": "49.98%",
                "Female": "49.36%",
                "Other": "0.66%"
            },
            "online_population_precent": "1.41%",
            "gdp_normal": "24.8T",
            "Education": {
                "Low": "6.00%",
                "Middle": "43.50%",
                "High": "49.47%",
                "Other/Prefer not to answer": "1.02%"
            },
            "name": "United States",
            "online_population": "294M",
            "Age Combined": {
                "10-20": "19.79%",
                "21-35": "28.65%",
                "36-50": "26.15%",
                "51-65": "25.41%"
            },
            "gdp_normal_precent": "4.31%",
            "total_population": "335M",
            "total_population_precent": "0.56%",
            "Work situation": {
                "Full-time employee": "49.53%",
                "Part-time employee": "10.69%",
                "Self-employed or independent": "3.50%",
                "Full-time homemaker": "5.59%",
                "Student": "7.64%",
                "Unemployed": "9.26%",
                "Retired": "11.83%",
                "Other": "1.96%"
            },
            "Players": {
                "Total Players": "29.29%",
                "Non Total Players": "70.71%",
                "Mobile Players": "51.62%",
                "Non Mobile Players": "48.38%",
                "PC Players": "72.96%",
                "Non PC Players": "27.04%",
                "Console Players": "38.50%",
                "Non Console Players": "61.50%"
            }
        },
        "ae": {
            "Esports Audience": {
                "Esports Enthusiasts": "6.34%",
                "Occasional Viewers": "14.98%",
                "Non-Esports Audience": "78.69%"
            },
            "gdp_capita_precent": "3.92%",
            "Persona": {
                "The Ultimate Gamer": "1.85%",
                "The All-Round Enthusiast": "2.77%",
                "The Mainstream Gamer": "18.40%",
                "The Community Gamer": "5.16%",
                "The Solo Gamer": "4.67%",
                "The Popcorn Gamer": "31.39%",
                "The Backseat Viewer": "4.75%",
                "The Time Filler": "15.86%",
                "The Lapsed Gamer": "9.13%",
                "Not a Persona": "6.03%"
            },
            "gdp_capita": "77.4K",
            "Income": {
                "Low": "19.64%",
                "Middle": "36.88%",
                "High": "35.91%",
                "Other/Prefer not to answer": "7.57%"
            },
            "Gender": {
                "Male": "70.76%",
                "Female": "29.24%",
                "Other": "0.00%"
            },
            "online_population_precent": "1.26%",
            "gdp_normal": "428B",
            "Education": {
                "Low": "4.67%",
                "Middle": "28.61%",
                "High": "65.69%",
                "Other/Prefer not to answer": "1.02%"
            },
            "name": "United Arab Emirat",
            "online_population": "9.58M",
            "Age Combined": {
                "10-20": "17.20%",
                "21-35": "53.10%",
                "36-50": "29.70%",
                "51-65": "0.00%"
            },
            "gdp_normal_precent": "3.74%",
            "total_population": "10.1M",
            "total_population_precent": "0.81%",
            "Work situation": {
                "Full-time employee": "65.23%",
                "Part-time employee": "7.07%",
                "Self-employed or independent": "6.99%",
                "Full-time homemaker": "7.76%",
                "Student": "6.77%",
                "Unemployed": "5.77%",
                "Retired": "0.41%",
                "Other": "0.00%"
            },
            "Players": {
                "Total Players": "19.91%",
                "Non Total Players": "80.09%",
                "Mobile Players": "36.59%",
                "Non Mobile Players": "63.41%",
                "PC Players": "77.59%",
                "Non PC Players": "22.41%",
                "Console Players": "22.09%",
                "Non Console Players": "77.91%"
            }
        },
        "in": {
            "Esports Audience": {
                "Esports Enthusiasts": "20.16%",
                "Occasional Viewers": "20.70%",
                "Non-Esports Audience": "59.13%"
            },
            "gdp_capita_precent": "7.92%",
            "Persona": {
                "The Ultimate Gamer": "2.75%",
                "The All-Round Enthusiast": "3.75%",
                "The Mainstream Gamer": "19.04%",
                "The Community Gamer": "5.77%",
                "The Solo Gamer": "4.91%",
                "The Popcorn Gamer": "42.61%",
                "The Backseat Viewer": "1.99%",
                "The Time Filler": "12.65%",
                "The Lapsed Gamer": "3.39%",
                "Not a Persona": "3.13%"
            },
            "gdp_capita": "8.08K",
            "Income": {
                "Low": "19.44%",
                "Middle": "36.04%",
                "High": "40.85%",
                "Other/Prefer not to answer": "3.67%"
            },
            "Gender": {
                "Male": "59.80%",
                "Female": "40.12%",
                "Other": "0.08%"
            },
            "online_population_precent": "6.14%",
            "gdp_normal": "3.25T",
            "Education": {
                "Low": "5.22%",
                "Middle": "18.36%",
                "High": "76.08%",
                "Other/Prefer not to answer": "0.34%"
            },
            "name": "India",
            "online_population": "738M",
            "Age Combined": {
                "10-20": "34.38%",
                "21-35": "42.23%",
                "36-50": "23.40%",
                "51-65": "0.00%"
            },
            "gdp_normal_precent": "8.00%",
            "total_population": "1.41B",
            "total_population_precent": "0.91%",
            "Work situation": {
                "Full-time employee": "55.72%",
                "Part-time employee": "7.13%",
                "Self-employed or independent": "12.22%",
                "Full-time homemaker": "2.63%",
                "Student": "19.55%",
                "Unemployed": "2.62%",
                "Retired": "0.12%",
                "Other": "0.00%"
            },
            "Players": {
                "Total Players": "8.52%",
                "Non Total Players": "91.48%",
                "Mobile Players": "19.30%",
                "Non Mobile Players": "80.70%",
                "PC Players": "56.70%",
                "Non PC Players": "43.30%",
                "Console Players": "26.84%",
                "Non Console Players": "73.16%"
            }
        },
        "za": {
            "Esports Audience": {
                "Esports Enthusiasts": "9.51%",
                "Occasional Viewers": "12.44%",
                "Non-Esports Audience": "78.06%"
            },
            "gdp_capita_precent": "2.15%",
            "Persona": {
                "The Ultimate Gamer": "3.03%",
                "The All-Round Enthusiast": "4.60%",
                "The Mainstream Gamer": "20.50%",
                "The Community Gamer": "4.19%",
                "The Solo Gamer": "4.67%",
                "The Popcorn Gamer": "25.60%",
                "The Backseat Viewer": "3.02%",
                "The Time Filler": "21.92%",
                "The Lapsed Gamer": "8.68%",
                "Not a Persona": "3.79%"
            },
            "gdp_capita": "14.7K",
            "Income": {
                "Low": "23.09%",
                "Middle": "29.51%",
                "High": "38.42%",
                "Other/Prefer not to answer": "8.98%"
            },
            "Gender": {
                "Male": "50.95%",
                "Female": "48.75%",
                "Other": "0.30%"
            },
            "online_population_precent": "3.97%",
            "gdp_normal": "435B",
            "Education": {
                "Low": "10.39%",
                "Middle": "61.03%",
                "High": "27.60%",
                "Other/Prefer not to answer": "0.98%"
            },
            "name": "South Africa",
            "online_population": "41.2M",
            "Age Combined": {
                "10-20": "30.92%",
                "21-35": "45.92%",
                "36-50": "23.16%",
                "51-65": "0.00%"
            },
            "gdp_normal_precent": "4.13%",
            "total_population": "60.8M",
            "total_population_precent": "1.13%",
            "Work situation": {
                "Full-time employee": "46.17%",
                "Part-time employee": "9.49%",
                "Self-employed or independent": "13.02%",
                "Full-time homemaker": "1.17%",
                "Student": "18.35%",
                "Unemployed": "11.11%",
                "Retired": "0.69%",
                "Other": "0.00%"
            },
            "Players": {
                "Total Players": "15.50%",
                "Non Total Players": "84.50%",
                "Mobile Players": "28.28%",
                "Non Mobile Players": "71.72%",
                "PC Players": "69.13%",
                "Non PC Players": "30.87%",
                "Console Players": "25.00%",
                "Non Console Players": "75.00%"
            }
        },
        "kr": {
            "Esports Audience": {
                "Esports Enthusiasts": "9.91%",
                "Occasional Viewers": "12.16%",
                "Non-Esports Audience": "77.92%"
            },
            "gdp_capita_precent": "5.05%",
            "Persona": {
                "The Ultimate Gamer": "5.14%",
                "The All-Round Enthusiast": "3.65%",
                "The Mainstream Gamer": "18.53%",
                "The Community Gamer": "3.60%",
                "The Solo Gamer": "4.31%",
                "The Popcorn Gamer": "16.52%",
                "The Backseat Viewer": "3.56%",
                "The Time Filler": "20.55%",
                "The Lapsed Gamer": "6.22%",
                "Not a Persona": "17.91%"
            },
            "gdp_capita": "51.2K",
            "Income": {
                "Low": "30.14%",
                "Middle": "36.81%",
                "High": "29.75%",
                "Other/Prefer not to answer": "3.31%"
            },
            "Gender": {
                "Male": "51.73%",
                "Female": "48.12%",
                "Other": "0.15%"
            },
            "online_population_precent": "0.42%",
            "gdp_normal": "1.91T",
            "Education": {
                "Low": "4.45%",
                "Middle": "21.21%",
                "High": "73.53%",
                "Other/Prefer not to answer": "0.81%"
            },
            "name": "South Korea",
            "online_population": "49.2M",
            "Age Combined": {
                "10-20": "13.64%",
                "21-35": "25.85%",
                "36-50": "30.57%",
                "51-65": "29.95%"
            },
            "gdp_normal_precent": "5.30%",
            "total_population": "51.3M",
            "total_population_precent": "0.02%",
            "Work situation": {
                "Full-time employee": "53.94%",
                "Part-time employee": "7.80%",
                "Self-employed or independent": "8.37%",
                "Full-time homemaker": "10.20%",
                "Student": "9.57%",
                "Unemployed": "6.72%",
                "Retired": "1.14%",
                "Other": "2.25%"
            },
            "Players": {
                "Total Players": "27.69%",
                "Non Total Players": "72.31%",
                "Mobile Players": "40.72%",
                "Non Mobile Players": "59.28%",
                "PC Players": "59.07%",
                "Non PC Players": "40.93%",
                "Console Players": "20.38%",
                "Non Console Players": "79.62%"
            }
        },
        "cn": {
            "Esports Audience": {
                "Esports Enthusiasts": "20.21%",
                "Occasional Viewers": "14.27%",
                "Non-Esports Audience": "65.52%"
            },
            "gdp_capita_precent": "7.53%",
            "Persona": {
                "The Ultimate Gamer": "1.92%",
                "The All-Round Enthusiast": "3.07%",
                "The Mainstream Gamer": "15.96%",
                "The Community Gamer": "4.85%",
                "The Solo Gamer": "4.38%",
                "The Popcorn Gamer": "26.12%",
                "The Backseat Viewer": "3.85%",
                "The Time Filler": "10.72%",
                "The Lapsed Gamer": "5.50%",
                "Not a Persona": "23.64%"
            },
            "gdp_capita": "20.7K",
            "Income": {
                "Low": "4.21%",
                "Middle": "74.56%",
                "High": "20.77%",
                "Other/Prefer not to answer": "0.47%"
            },
            "Gender": {
                "Male": "53.31%",
                "Female": "44.35%",
                "Other": "2.34%"
            },
            "online_population_precent": "3.17%",
            "gdp_normal": "18.5T",
            "Education": {
                "Low": "1.46%",
                "Middle": "16.29%",
                "High": "81.75%",
                "Other/Prefer not to answer": "0.51%"
            },
            "name": "China",
            "online_population": "1.07B",
            "Age Combined": {
                "10-20": "22.50%",
                "21-35": "47.68%",
                "36-50": "29.82%",
                "51-65": "0.00%"
            },
            "gdp_normal_precent": "8.15%",
            "total_population": "1.45B",
            "total_population_precent": "0.23%",
            "Work situation": {
                "Full-time employee": "80.01%",
                "Part-time employee": "2.12%",
                "Self-employed or independent": "2.14%",
                "Full-time homemaker": "0.55%",
                "Student": "13.98%",
                "Unemployed": "0.30%",
                "Retired": "0.91%",
                "Other": "0.00%"
            },
            "Players": {
                "Total Players": "32.98%",
                "Non Total Players": "67.02%",
                "Mobile Players": "38.58%",
                "Non Mobile Players": "61.42%",
                "PC Players": "63.25%",
                "Non PC Players": "36.75%",
                "Console Players": "15.35%",
                "Non Console Players": "84.65%"
            }
        },
        "it": {
            "Esports Audience": {
                "Esports Enthusiasts": "4.76%",
                "Occasional Viewers": "9.98%",
                "Non-Esports Audience": "85.26%"
            },
            "gdp_capita_precent": "4.98%",
            "Persona": {
                "The Ultimate Gamer": "4.62%",
                "The All-Round Enthusiast": "4.38%",
                "The Mainstream Gamer": "18.92%",
                "The Community Gamer": "4.94%",
                "The Solo Gamer": "2.34%",
                "The Popcorn Gamer": "16.13%",
                "The Backseat Viewer": "1.63%",
                "The Time Filler": "27.03%",
                "The Lapsed Gamer": "9.88%",
                "Not a Persona": "10.14%"
            },
            "gdp_capita": "43.4K",
            "Income": {
                "Low": "18.93%",
                "Middle": "39.58%",
                "High": "29.56%",
                "Other/Prefer not to answer": "11.93%"
            },
            "Gender": {
                "Male": "50.46%",
                "Female": "49.25%",
                "Other": "0.29%"
            },
            "online_population_precent": "0.96%",
            "gdp_normal": "2.11T",
            "Education": {
                "Low": "11.14%",
                "Middle": "49.02%",
                "High": "39.53%",
                "Other/Prefer not to answer": "0.31%"
            },
            "name": "Italy",
            "online_population": "53.9M",
            "Age Combined": {
                "10-20": "15.57%",
                "21-35": "23.38%",
                "36-50": "30.42%",
                "51-65": "30.63%"
            },
            "gdp_normal_precent": "4.40%",
            "total_population": "60.4M",
            "total_population_precent": "-0.18%",
            "Work situation": {
                "Full-time employee": "42.80%",
                "Part-time employee": "11.31%",
                "Self-employed or independent": "11.20%",
                "Full-time homemaker": "8.57%",
                "Student": "11.80%",
                "Unemployed": "9.69%",
                "Retired": "4.02%",
                "Other": "0.62%"
            },
            "Players": {
                "Total Players": "21.64%",
                "Non Total Players": "78.36%",
                "Mobile Players": "47.21%",
                "Non Mobile Players": "52.79%",
                "PC Players": "64.70%",
                "Non PC Players": "35.30%",
                "Console Players": "41.15%",
                "Non Console Players": "58.85%"
            }
        },
        "mx": {
            "Esports Audience": {
                "Esports Enthusiasts": "8.83%",
                "Occasional Viewers": "16.29%",
                "Non-Esports Audience": "74.89%"
            },
            "gdp_capita_precent": "3.61%",
            "Persona": {
                "The Ultimate Gamer": "2.87%",
                "The All-Round Enthusiast": "3.58%",
                "The Mainstream Gamer": "17.11%",
                "The Community Gamer": "2.58%",
                "The Solo Gamer": "4.33%",
                "The Popcorn Gamer": "29.20%",
                "The Backseat Viewer": "2.57%",
                "The Time Filler": "22.41%",
                "The Lapsed Gamer": "8.46%",
                "Not a Persona": "6.90%"
            },
            "gdp_capita": "22.1K",
            "Income": {
                "Low": "14.84%",
                "Middle": "30.55%",
                "High": "45.47%",
                "Other/Prefer not to answer": "9.14%"
            },
            "Gender": {
                "Male": "49.72%",
                "Female": "49.84%",
                "Other": "0.44%"
            },
            "online_population_precent": "2.82%",
            "gdp_normal": "1.37T",
            "Education": {
                "Low": "1.54%",
                "Middle": "42.72%",
                "High": "55.06%",
                "Other/Prefer not to answer": "0.67%"
            },
            "name": "Mexico",
            "online_population": "98.7M",
            "Age Combined": {
                "10-20": "34.30%",
                "21-35": "35.51%",
                "36-50": "22.07%",
                "51-65": "8.12%"
            },
            "gdp_normal_precent": "5.23%",
            "total_population": "132M",
            "total_population_precent": "0.95%",
            "Work situation": {
                "Full-time employee": "47.86%",
                "Part-time employee": "10.23%",
                "Self-employed or independent": "12.27%",
                "Full-time homemaker": "5.89%",
                "Student": "17.80%",
                "Unemployed": "4.37%",
                "Retired": "1.21%",
                "Other": "0.37%"
            },
            "Players": {
                "Total Players": "17.93%",
                "Non Total Players": "82.07%",
                "Mobile Players": "31.52%",
                "Non Mobile Players": "68.48%",
                "PC Players": "74.19%",
                "Non PC Players": "25.81%",
                "Console Players": "39.30%",
                "Non Console Players": "60.70%"
            }
        },
        "my": {
            "Esports Audience": {
                "Esports Enthusiasts": "13.29%",
                "Occasional Viewers": "16.12%",
                "Non-Esports Audience": "70.59%"
            },
            "gdp_capita_precent": "6.65%",
            "Persona": {
                "The Ultimate Gamer": "3.43%",
                "The All-Round Enthusiast": "2.72%",
                "The Mainstream Gamer": "19.87%",
                "The Community Gamer": "5.24%",
                "The Solo Gamer": "3.65%",
                "The Popcorn Gamer": "28.14%",
                "The Backseat Viewer": "3.49%",
                "The Time Filler": "18.50%",
                "The Lapsed Gamer": "6.40%",
                "Not a Persona": "8.57%"
            },
            "gdp_capita": "31.2K",
            "Income": {
                "Low": "24.79%",
                "Middle": "23.89%",
                "High": "41.91%",
                "Other/Prefer not to answer": "9.40%"
            },
            "Gender": {
                "Male": "50.69%",
                "Female": "49.16%",
                "Other": "0.15%"
            },
            "online_population_precent": "2.54%",
            "gdp_normal": "415B",
            "Education": {
                "Low": "8.35%",
                "Middle": "30.99%",
                "High": "58.37%",
                "Other/Prefer not to answer": "2.29%"
            },
            "name": "Malaysia",
            "online_population": "29.6M",
            "Age Combined": {
                "10-20": "31.55%",
                "21-35": "37.79%",
                "36-50": "30.66%",
                "51-65": "0.00%"
            },
            "gdp_normal_precent": "9.17%",
            "total_population": "33.2M",
            "total_population_precent": "1.18%",
            "Work situation": {
                "Full-time employee": "55.81%",
                "Part-time employee": "6.09%",
                "Self-employed or independent": "12.16%",
                "Full-time homemaker": "4.73%",
                "Student": "15.64%",
                "Unemployed": "4.29%",
                "Retired": "0.05%",
                "Other": "1.22%"
            },
            "Players": {
                "Total Players": "18.45%",
                "Non Total Players": "81.55%",
                "Mobile Players": "31.17%",
                "Non Mobile Players": "68.83%",
                "PC Players": "71.81%",
                "Non PC Players": "28.19%",
                "Console Players": "17.03%",
                "Non Console Players": "82.97%"
            }
        },
        "es": {
            "Esports Audience": {
                "Esports Enthusiasts": "6.66%",
                "Occasional Viewers": "13.66%",
                "Non-Esports Audience": "79.68%"
            },
            "gdp_capita_precent": "4.26%",
            "Persona": {
                "The Ultimate Gamer": "4.97%",
                "The All-Round Enthusiast": "3.93%",
                "The Mainstream Gamer": "20.84%",
                "The Community Gamer": "5.81%",
                "The Solo Gamer": "4.66%",
                "The Popcorn Gamer": "14.74%",
                "The Backseat Viewer": "0.91%",
                "The Time Filler": "27.23%",
                "The Lapsed Gamer": "9.02%",
                "Not a Persona": "7.88%"
            },
            "gdp_capita": "45.8K",
            "Income": {
                "Low": "21.73%",
                "Middle": "40.69%",
                "High": "29.91%",
                "Other/Prefer not to answer": "7.67%"
            },
            "Gender": {
                "Male": "50.38%",
                "Female": "49.43%",
                "Other": "0.19%"
            },
            "online_population_precent": "0.89%",
            "gdp_normal": "1.57T",
            "Education": {
                "Low": "3.57%",
                "Middle": "28.78%",
                "High": "67.44%",
                "Other/Prefer not to answer": "0.21%"
            },
            "name": "Spain",
            "online_population": "42.7M",
            "Age Combined": {
                "10-20": "15.93%",
                "21-35": "21.88%",
                "36-50": "32.92%",
                "51-65": "29.28%"
            },
            "gdp_normal_precent": "5.33%",
            "total_population": "46.7M",
            "total_population_precent": "-0.09%",
            "Work situation": {
                "Full-time employee": "55.15%",
                "Part-time employee": "10.38%",
                "Self-employed or independent": "6.17%",
                "Full-time homemaker": "4.07%",
                "Student": "9.53%",
                "Unemployed": "10.09%",
                "Retired": "3.72%",
                "Other": "0.90%"
            },
            "Players": {
                "Total Players": "17.81%",
                "Non Total Players": "82.19%",
                "Mobile Players": "39.80%",
                "Non Mobile Players": "60.20%",
                "PC Players": "58.65%",
                "Non PC Players": "41.35%",
                "Console Players": "48.01%",
                "Non Console Players": "51.99%"
            }
        },
        "ar": {
            "Esports Audience": {
                "Esports Enthusiasts": "8.52%",
                "Occasional Viewers": "13.36%",
                "Non-Esports Audience": "78.13%"
            },
            "gdp_capita_precent": "3.24%",
            "Persona": {
                "The Ultimate Gamer": "3.07%",
                "The All-Round Enthusiast": "3.56%",
                "The Mainstream Gamer": "14.87%",
                "The Community Gamer": "3.09%",
                "The Solo Gamer": "3.16%",
                "The Popcorn Gamer": "28.84%",
                "The Backseat Viewer": "3.32%",
                "The Time Filler": "23.52%",
                "The Lapsed Gamer": "9.70%",
                "Not a Persona": "6.86%"
            },
            "gdp_capita": "23.9K",
            "Income": {
                "Low": "9.22%",
                "Middle": "11.37%",
                "High": "64.68%",
                "Other/Prefer not to answer": "14.74%"
            },
            "Gender": {
                "Male": "50.33%",
                "Female": "49.37%",
                "Other": "0.31%"
            },
            "online_population_precent": "2.31%",
            "gdp_normal": "484B",
            "Education": {
                "Low": "11.82%",
                "Middle": "50.13%",
                "High": "37.51%",
                "Other/Prefer not to answer": "0.54%"
            },
            "name": "Argentina",
            "online_population": "37.4M",
            "Age Combined": {
                "10-20": "29.95%",
                "21-35": "38.11%",
                "36-50": "22.87%",
                "51-65": "9.07%"
            },
            "gdp_normal_precent": "0.46%",
            "total_population": "46.0M",
            "total_population_precent": "0.86%",
            "Work situation": {
                "Full-time employee": "37.07%",
                "Part-time employee": "16.32%",
                "Self-employed or independent": "14.69%",
                "Full-time homemaker": "4.47%",
                "Student": "17.57%",
                "Unemployed": "7.55%",
                "Retired": "1.54%",
                "Other": "0.79%"
            },
            "Players": {
                "Total Players": "19.89%",
                "Non Total Players": "80.11%",
                "Mobile Players": "33.19%",
                "Non Mobile Players": "66.81%",
                "PC Players": "65.99%",
                "Non PC Players": "34.01%",
                "Console Players": "24.91%",
                "Non Console Players": "75.09%"
            }
        },
        "au": {
            "Esports Audience": {
                "Esports Enthusiasts": "3.84%",
                "Occasional Viewers": "6.96%",
                "Non-Esports Audience": "89.20%"
            },
            "gdp_capita_precent": "3.76%",
            "Persona": {
                "The Ultimate Gamer": "3.55%",
                "The All-Round Enthusiast": "4.44%",
                "The Mainstream Gamer": "19.33%",
                "The Community Gamer": "6.32%",
                "The Solo Gamer": "2.58%",
                "The Popcorn Gamer": "6.93%",
                "The Backseat Viewer": "1.16%",
                "The Time Filler": "23.39%",
                "The Lapsed Gamer": "15.49%",
                "Not a Persona": "16.81%"
            },
            "gdp_capita": "59.1K",
            "Income": {
                "Low": "31.42%",
                "Middle": "27.18%",
                "High": "31.28%",
                "Other/Prefer not to answer": "10.12%"
            },
            "Gender": {
                "Male": "50.25%",
                "Female": "49.39%",
                "Other": "0.36%"
            },
            "online_population_precent": "1.65%",
            "gdp_normal": "1.68T",
            "Education": {
                "Low": "12.99%",
                "Middle": "34.19%",
                "High": "52.24%",
                "Other/Prefer not to answer": "0.59%"
            },
            "name": "Australia",
            "online_population": "23.8M",
            "Age Combined": {
                "10-20": "19.46%",
                "21-35": "29.26%",
                "36-50": "28.49%",
                "51-65": "22.79%"
            },
            "gdp_normal_precent": "5.44%",
            "total_population": "26.1M",
            "total_population_precent": "1.04%",
            "Work situation": {
                "Full-time employee": "39.66%",
                "Part-time employee": "20.07%",
                "Self-employed or independent": "4.70%",
                "Full-time homemaker": "6.84%",
                "Student": "8.38%",
                "Unemployed": "10.32%",
                "Retired": "7.65%",
                "Other": "2.39%"
            },
            "Players": {
                "Total Players": "33.45%",
                "Non Total Players": "66.55%",
                "Mobile Players": "57.62%",
                "Non Mobile Players": "42.38%",
                "PC Players": "70.49%",
                "Non PC Players": "29.51%",
                "Console Players": "34.99%",
                "Non Console Players": "65.01%"
            }
        },
        "th": {
            "Esports Audience": {
                "Esports Enthusiasts": "21.79%",
                "Occasional Viewers": "16.41%",
                "Non-Esports Audience": "61.80%"
            },
            "gdp_capita_precent": "6.08%",
            "Persona": {
                "The Ultimate Gamer": "2.51%",
                "The All-Round Enthusiast": "3.16%",
                "The Mainstream Gamer": "16.50%",
                "The Community Gamer": "5.55%",
                "The Solo Gamer": "1.71%",
                "The Popcorn Gamer": "32.97%",
                "The Backseat Viewer": "8.63%",
                "The Time Filler": "9.32%",
                "The Lapsed Gamer": "6.16%",
                "Not a Persona": "13.48%"
            },
            "gdp_capita": "20.4K",
            "Income": {
                "Low": "9.59%",
                "Middle": "37.14%",
                "High": "51.28%",
                "Other/Prefer not to answer": "2.00%"
            },
            "Gender": {
                "Male": "49.42%",
                "Female": "49.88%",
                "Other": "0.70%"
            },
            "online_population_precent": "4.52%",
            "gdp_normal": "586B",
            "Education": {
                "Low": "11.19%",
                "Middle": "16.60%",
                "High": "71.29%",
                "Other/Prefer not to answer": "0.92%"
            },
            "name": "Thailand",
            "online_population": "55.8M",
            "Age Combined": {
                "10-20": "30.48%",
                "21-35": "45.03%",
                "36-50": "24.49%",
                "51-65": "0.00%"
            },
            "gdp_normal_precent": "5.73%",
            "total_population": "70.1M",
            "total_population_precent": "0.13%",
            "Work situation": {
                "Full-time employee": "64.79%",
                "Part-time employee": "3.30%",
                "Self-employed or independent": "16.35%",
                "Full-time homemaker": "0.92%",
                "Student": "10.62%",
                "Unemployed": "3.21%",
                "Retired": "0.81%",
                "Other": "0.00%"
            },
            "Players": {
                "Total Players": "28.27%",
                "Non Total Players": "71.73%",
                "Mobile Players": "41.10%",
                "Non Mobile Players": "58.90%",
                "PC Players": "66.65%",
                "Non PC Players": "33.35%",
                "Console Players": "19.29%",
                "Non Console Players": "80.71%"
            }
        },
        "ph": {
            "Esports Audience": {
                "Esports Enthusiasts": "24.82%",
                "Occasional Viewers": "23.92%",
                "Non-Esports Audience": "51.27%"
            },
            "gdp_capita_precent": "7.69%",
            "Persona": {
                "The Ultimate Gamer": "2.52%",
                "The All-Round Enthusiast": "3.64%",
                "The Mainstream Gamer": "19.85%",
                "The Community Gamer": "6.55%",
                "The Solo Gamer": "3.97%",
                "The Popcorn Gamer": "43.35%",
                "The Backseat Viewer": "1.77%",
                "The Time Filler": "13.18%",
                "The Lapsed Gamer": "2.48%",
                "Not a Persona": "2.68%"
            },
            "gdp_capita": "9.58K",
            "Income": {
                "Low": "8.13%",
                "Middle": "15.96%",
                "High": "67.18%",
                "Other/Prefer not to answer": "8.73%"
            },
            "Gender": {
                "Male": "50.00%",
                "Female": "49.31%",
                "Other": "0.70%"
            },
            "online_population_precent": "4.37%",
            "gdp_normal": "406B",
            "Education": {
                "Low": "2.54%",
                "Middle": "21.75%",
                "High": "75.11%",
                "Other/Prefer not to answer": "0.60%"
            },
            "name": "Philippines",
            "online_population": "82.5M",
            "Age Combined": {
                "10-20": "34.18%",
                "21-35": "45.91%",
                "36-50": "19.90%",
                "51-65": "0.00%"
            },
            "gdp_normal_precent": "7.79%",
            "total_population": "113M",
            "total_population_precent": "1.28%",
            "Work situation": {
                "Full-time employee": "44.75%",
                "Part-time employee": "9.01%",
                "Self-employed or independent": "14.77%",
                "Full-time homemaker": "2.98%",
                "Student": "21.72%",
                "Unemployed": "6.06%",
                "Retired": "0.71%",
                "Other": "0.00%"
            },
            "Players": {
                "Total Players": "6.93%",
                "Non Total Players": "93.07%",
                "Mobile Players": "14.68%",
                "Non Mobile Players": "85.32%",
                "PC Players": "56.67%",
                "Non PC Players": "43.33%",
                "Console Players": "17.80%",
                "Non Console Players": "82.20%"
            }
        },
        "vn": {
            "Esports Audience": {
                "Esports Enthusiasts": "37.31%",
                "Occasional Viewers": "16.90%",
                "Non-Esports Audience": "45.79%"
            },
            "gdp_capita_precent": "8.44%",
            "Persona": {
                "The Ultimate Gamer": "3.46%",
                "The All-Round Enthusiast": "3.16%",
                "The Mainstream Gamer": "18.00%",
                "The Community Gamer": "6.74%",
                "The Solo Gamer": "2.52%",
                "The Popcorn Gamer": "47.14%",
                "The Backseat Viewer": "1.26%",
                "The Time Filler": "12.08%",
                "The Lapsed Gamer": "3.24%",
                "Not a Persona": "2.41%"
            },
            "gdp_capita": "12.6K",
            "Income": {
                "Low": "6.91%",
                "Middle": "21.88%",
                "High": "69.06%",
                "Other/Prefer not to answer": "2.15%"
            },
            "Gender": {
                "Male": "51.48%",
                "Female": "47.92%",
                "Other": "0.60%"
            },
            "online_population_precent": "3.21%",
            "gdp_normal": "415B",
            "Education": {
                "Low": "0.17%",
                "Middle": "20.64%",
                "High": "78.09%",
                "Other/Prefer not to answer": "1.10%"
            },
            "name": "Vietnam",
            "online_population": "77.7M",
            "Age Combined": {
                "10-20": "26.91%",
                "21-35": "52.05%",
                "36-50": "21.05%",
                "51-65": "0.00%"
            },
            "gdp_normal_precent": "11.10%",
            "total_population": "99.0M",
            "total_population_precent": "0.74%",
            "Work situation": {
                "Full-time employee": "61.73%",
                "Part-time employee": "6.44%",
                "Self-employed or independent": "10.08%",
                "Full-time homemaker": "0.63%",
                "Student": "16.70%",
                "Unemployed": "1.30%",
                "Retired": "3.12%",
                "Other": "0.00%"
            },
            "Players": {
                "Total Players": "6.91%",
                "Non Total Players": "93.09%",
                "Mobile Players": "13.81%",
                "Non Mobile Players": "86.19%",
                "PC Players": "49.09%",
                "Non PC Players": "50.91%",
                "Console Players": "21.55%",
                "Non Console Players": "78.45%"
            }
        },
        "pl": {
            "Esports Audience": {
                "Esports Enthusiasts": "6.05%",
                "Occasional Viewers": "11.28%",
                "Non-Esports Audience": "82.67%"
            },
            "gdp_capita_precent": "5.79%",
            "Persona": {
                "The Ultimate Gamer": "4.34%",
                "The All-Round Enthusiast": "4.12%",
                "The Mainstream Gamer": "19.73%",
                "The Community Gamer": "4.37%",
                "The Solo Gamer": "2.57%",
                "The Popcorn Gamer": "13.63%",
                "The Backseat Viewer": "1.80%",
                "The Time Filler": "23.69%",
                "The Lapsed Gamer": "14.75%",
                "Not a Persona": "11.00%"
            },
            "gdp_capita": "40.3K",
            "Income": {
                "Low": "27.90%",
                "Middle": "31.79%",
                "High": "27.37%",
                "Other/Prefer not to answer": "12.93%"
            },
            "Gender": {
                "Male": "50.48%",
                "Female": "49.32%",
                "Other": "0.20%"
            },
            "online_population_precent": "1.15%",
            "gdp_normal": "720B",
            "Education": {
                "Low": "17.40%",
                "Middle": "34.84%",
                "High": "46.93%",
                "Other/Prefer not to answer": "0.83%"
            },
            "name": "Poland",
            "online_population": "32.8M",
            "Age Combined": {
                "10-20": "16.72%",
                "21-35": "28.24%",
                "36-50": "34.46%",
                "51-65": "20.58%"
            },
            "gdp_normal_precent": "7.43%",
            "total_population": "37.7M",
            "total_population_precent": "-0.19%",
            "Work situation": {
                "Full-time employee": "63.46%",
                "Part-time employee": "5.02%",
                "Self-employed or independent": "5.46%",
                "Full-time homemaker": "5.04%",
                "Student": "5.66%",
                "Unemployed": "4.59%",
                "Retired": "6.68%",
                "Other": "4.10%"
            },
            "Players": {
                "Total Players": "27.55%",
                "Non Total Players": "72.45%",
                "Mobile Players": "57.80%",
                "Non Mobile Players": "42.20%",
                "PC Players": "54.70%",
                "Non PC Players": "45.30%",
                "Console Players": "32.07%",
                "Non Console Players": "67.93%"
            }
        },
        "nl": {
            "Esports Audience": {
                "Esports Enthusiasts": "3.70%",
                "Occasional Viewers": "5.28%",
                "Non-Esports Audience": "91.02%"
            },
            "gdp_capita_precent": "4.01%",
            "Persona": {
                "The Ultimate Gamer": "3.50%",
                "The All-Round Enthusiast": "4.63%",
                "The Mainstream Gamer": "20.44%",
                "The Community Gamer": "5.16%",
                "The Solo Gamer": "2.46%",
                "The Popcorn Gamer": "6.53%",
                "The Backseat Viewer": "1.63%",
                "The Time Filler": "20.39%",
                "The Lapsed Gamer": "14.15%",
                "Not a Persona": "21.12%"
            },
            "gdp_capita": "65.3K",
            "Income": {
                "Low": "23.90%",
                "Middle": "29.87%",
                "High": "27.40%",
                "Other/Prefer not to answer": "18.84%"
            },
            "Gender": {
                "Male": "50.46%",
                "Female": "49.30%",
                "Other": "0.25%"
            },
            "online_population_precent": "0.59%",
            "gdp_normal": "1.07T",
            "Education": {
                "Low": "23.10%",
                "Middle": "30.39%",
                "High": "45.97%",
                "Other/Prefer not to answer": "0.53%"
            },
            "name": "Netherlands",
            "online_population": "16.6M",
            "Age Combined": {
                "10-20": "17.53%",
                "21-35": "26.36%",
                "36-50": "26.16%",
                "51-65": "29.96%"
            },
            "gdp_normal_precent": "5.10%",
            "total_population": "17.2M",
            "total_population_precent": "0.22%",
            "Work situation": {
                "Full-time employee": "44.42%",
                "Part-time employee": "18.89%",
                "Self-employed or independent": "4.42%",
                "Full-time homemaker": "6.58%",
                "Student": "8.46%",
                "Unemployed": "5.64%",
                "Retired": "3.16%",
                "Other": "8.43%"
            },
            "Players": {
                "Total Players": "36.89%",
                "Non Total Players": "63.11%",
                "Mobile Players": "60.64%",
                "Non Mobile Players": "39.36%",
                "PC Players": "73.42%",
                "Non PC Players": "26.58%",
                "Console Players": "31.35%",
                "Non Console Players": "68.65%"
            }
        },
        "tr": {
            "Esports Audience": {
                "Esports Enthusiasts": "13.90%",
                "Occasional Viewers": "17.54%",
                "Non-Esports Audience": "68.56%"
            },
            "gdp_capita_precent": "4.52%",
            "Persona": {
                "The Ultimate Gamer": "3.26%",
                "The All-Round Enthusiast": "3.47%",
                "The Mainstream Gamer": "20.75%",
                "The Community Gamer": "3.78%",
                "The Solo Gamer": "5.02%",
                "The Popcorn Gamer": "36.87%",
                "The Backseat Viewer": "2.18%",
                "The Time Filler": "17.28%",
                "The Lapsed Gamer": "3.49%",
                "Not a Persona": "3.91%"
            },
            "gdp_capita": "35.6K",
            "Income": {
                "Low": "3.26%",
                "Middle": "5.60%",
                "High": "88.35%",
                "Other/Prefer not to answer": "2.80%"
            },
            "Gender": {
                "Male": "51.21%",
                "Female": "48.69%",
                "Other": "0.09%"
            },
            "online_population_precent": "3.21%",
            "gdp_normal": "845B",
            "Education": {
                "Low": "5.79%",
                "Middle": "30.24%",
                "High": "63.17%",
                "Other/Prefer not to answer": "0.80%"
            },
            "name": "Turkey",
            "online_population": "70.5M",
            "Age Combined": {
                "10-20": "29.82%",
                "21-35": "41.20%",
                "36-50": "28.98%",
                "51-65": "0.00%"
            },
            "gdp_normal_precent": "12.10%",
            "total_population": "85.6M",
            "total_population_precent": "0.44%",
            "Work situation": {
                "Full-time employee": "59.50%",
                "Part-time employee": "4.68%",
                "Self-employed or independent": "3.48%",
                "Full-time homemaker": "7.81%",
                "Student": "17.23%",
                "Unemployed": "6.27%",
                "Retired": "0.20%",
                "Other": "0.83%"
            },
            "Players": {
                "Total Players": "9.58%",
                "Non Total Players": "90.42%",
                "Mobile Players": "20.37%",
                "Non Mobile Players": "79.63%",
                "PC Players": "57.59%",
                "Non PC Players": "42.41%",
                "Console Players": "27.46%",
                "Non Console Players": "72.54%"
            }
        }
    }
} as any;

export const testSummaryData = {
  mobile: {
    revenue: 15975645566,
    revenuePrecent: 0.0158,
    rank: 5,
    rankChange: -3,
    xAxis: ['Feb', 'Mar', 'Apr', 'May'],
    yAxis: [158648856, 138648856, 188648856, 228648856],
  },
  pc: {
    revenue: 2497645566,
    revenuePrecent: -0.0158,
    rank: 5,
    rankChange: -3,
    xAxis: ['Feb', 'Mar', 'Apr', 'May'],
    yAxis: [158648856, 138648856, 188648856, 228648856],
  },
  console: {
    revenue: 999971111,
    revenuePrecent: -0.0158,
    rank: 1,
    rankChange: 3,
    xAxis: ['Feb', 'Mar', 'Apr', 'May'],
    yAxis: [158648856, 138648856, 188648856, 228648856],
  },
};

export const topMobileGameList = [
  {
    rank: 1,
    name: 'Minecraft',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/59e3e08e58f70149023836d187dfe8ae.jpg',
    desc: 'Supercell',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 2,
    name: 'Heads Up!',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/8e5f98e4d17c193742c3332f670a0117.jpg',
    desc: 'Supercell',
    revenue: 3468465482,
    precent: 0.13,
  },
  {
    rank: 3,
    name: 'Rovio Classics: Angry Birds',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/94a2be2ffd61c498e5dbf099c10fcfb1.jpg',
    desc: 'Supercell',
    revenue: 2468465482,
    precent: 0.12,
  },
  {
    rank: 4,
    name: 'Bloons TD 6',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/7e26ac10d95639a3300ab29d26623037.jpg',
    desc: 'Supercell',
    revenue: 1168465482,
    precent: 0.07,
  },
  {
    rank: 5,
    name: 'Poppy Playtime Chapter 1',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/6ba1f47fa8a742b0a0b433bd1681db67.jpg',
    desc: 'Supercell',
    revenue: 968465482,
    precent: 0.05,
  },
];

export const topMobileGameList10 = [
  {
    rank: 1,
    name: 'Minecraft',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/59e3e08e58f70149023836d187dfe8ae.jpg',
    desc: 'Supercell',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 2,
    name: 'Heads Up!',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/8e5f98e4d17c193742c3332f670a0117.jpg',
    desc: 'Supercell',
    revenue: 3468465482,
    precent: 0.13,
  },
  {
    rank: 3,
    name: 'Rovio Classics: Angry Birds',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/94a2be2ffd61c498e5dbf099c10fcfb1.jpg',
    desc: 'Supercell',
    revenue: 2468465482,
    precent: 0.12,
  },
  {
    rank: 4,
    name: 'Bloons TD 6',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/7e26ac10d95639a3300ab29d26623037.jpg',
    desc: 'Supercell',
    revenue: 1168465482,
    precent: 0.07,
  },
  {
    rank: 5,
    name: 'Poppy Playtime Chapter 1',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/6ba1f47fa8a742b0a0b433bd1681db67.jpg',
    desc: 'Supercell',
    revenue: 968465482,
    precent: 0.05,
  },
  {
    rank: 6,
    name: 'Minecraft',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/59e3e08e58f70149023836d187dfe8ae.jpg',
    desc: 'Supercell',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 7,
    name: 'Heads Up!',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/8e5f98e4d17c193742c3332f670a0117.jpg',
    desc: 'Supercell',
    revenue: 3468465482,
    precent: 0.13,
  },
  {
    rank: 8,
    name: 'Rovio Classics: Angry Birds',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/94a2be2ffd61c498e5dbf099c10fcfb1.jpg',
    desc: 'Supercell',
    revenue: 2468465482,
    precent: 0.12,
  },
  {
    rank: 9,
    name: 'Bloons TD 6',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/7e26ac10d95639a3300ab29d26623037.jpg',
    desc: 'Supercell',
    revenue: 1168465482,
    precent: 0.07,
  },
  {
    rank: 10,
    name: 'Poppy Playtime Chapter 1',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/6ba1f47fa8a742b0a0b433bd1681db67.jpg',
    desc: 'Supercell',
    revenue: 968465482,
    precent: 0.05,
  },
];

export const topPCGameList = [
  {
    rank: 1,
    name: 'The Day Before',
    gameIcon:
      'https://cdn.cloudflare.steamstatic.com/steam/apps/1372880/header.jpg?t=1651749444',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 2,
    name: 'The Day Before',
    gameIcon:
      'https://cdn.cloudflare.steamstatic.com/steam/apps/1372880/header.jpg?t=1651749444',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 3,
    name: 'The Day Before',
    gameIcon:
      'https://cdn.cloudflare.steamstatic.com/steam/apps/1372880/header.jpg?t=1651749444',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 4,
    name: 'The Day Before',
    gameIcon:
      'https://cdn.cloudflare.steamstatic.com/steam/apps/1372880/header.jpg?t=1651749444',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 5,
    name: 'The Day Before',
    gameIcon:
      'https://cdn.cloudflare.steamstatic.com/steam/apps/1372880/header.jpg?t=1651749444',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'United States',
    revenue: 5468465482,
    precent: 0.16,
  },
];

export const topPCGameList10 = [
  {
    rank: 1,
    name: 'The Day Before',
    gameIcon:
      'https://cdn.cloudflare.steamstatic.com/steam/apps/1372880/header.jpg?t=1651749444',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 2,
    name: 'The Day Before',
    gameIcon:
      'https://cdn.cloudflare.steamstatic.com/steam/apps/1372880/header.jpg?t=1651749444',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 3,
    name: 'The Day Before',
    gameIcon:
      'https://cdn.cloudflare.steamstatic.com/steam/apps/1372880/header.jpg?t=1651749444',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 4,
    name: 'The Day Before',
    gameIcon:
      'https://cdn.cloudflare.steamstatic.com/steam/apps/1372880/header.jpg?t=1651749444',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 5,
    name: 'The Day Before',
    gameIcon:
      'https://cdn.cloudflare.steamstatic.com/steam/apps/1372880/header.jpg?t=1651749444',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 6,
    name: 'The Day Before',
    gameIcon:
      'https://cdn.cloudflare.steamstatic.com/steam/apps/1372880/header.jpg?t=1651749444',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 7,
    name: 'The Day Before',
    gameIcon:
      'https://cdn.cloudflare.steamstatic.com/steam/apps/1372880/header.jpg?t=1651749444',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 8,
    name: 'The Day Before',
    gameIcon:
      'https://cdn.cloudflare.steamstatic.com/steam/apps/1372880/header.jpg?t=1651749444',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 9,
    name: 'The Day Before',
    gameIcon:
      'https://cdn.cloudflare.steamstatic.com/steam/apps/1372880/header.jpg?t=1651749444',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 10,
    name: 'The Day Before',
    gameIcon:
      'https://cdn.cloudflare.steamstatic.com/steam/apps/1372880/header.jpg?t=1651749444',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'United States',
    revenue: 5468465482,
    precent: 0.16,
  },
];

export const topCompanyGameList = [
  {
    rank: 1,
    name: 'Electronic Arts',
    companyIcon:
      'https://ogdb-cdn.intlgame.cn/company/5a6207e2-b868-9f41-5178-8d51d2c40a93.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Redwood City  United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 2,
    name: 'Tencent',
    companyIcon:
      'https://ogdb-cdn.intlgame.cn/company/3cae090b-ed2d-95f8-79a9-e32ca480258f.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/cn.svg',
    conutryName: 'Shenzhen  China',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 3,
    name: 'Electronic Arts',
    companyIcon:
      'https://ogdb-cdn.intlgame.cn/company/5a6207e2-b868-9f41-5178-8d51d2c40a93.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Redwood City  United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 4,
    name: 'Tencent',
    companyIcon:
      'https://ogdb-cdn.intlgame.cn/company/3cae090b-ed2d-95f8-79a9-e32ca480258f.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/cn.svg',
    conutryName: 'Shenzhen  China',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 5,
    name: 'Electronic Arts',
    companyIcon:
      'https://ogdb-cdn.intlgame.cn/company/5a6207e2-b868-9f41-5178-8d51d2c40a93.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Redwood City  United States',
    revenue: 5468465482,
    precent: 0.16,
  },
];

export const topCompanyGameList10 = [
  {
    rank: 1,
    name: 'Electronic Arts',
    companyIcon:
      'https://ogdb-cdn.intlgame.cn/company/5a6207e2-b868-9f41-5178-8d51d2c40a93.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Redwood City  United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 2,
    name: 'Tencent',
    companyIcon:
      'https://ogdb-cdn.intlgame.cn/company/3cae090b-ed2d-95f8-79a9-e32ca480258f.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/cn.svg',
    conutryName: 'Shenzhen  China',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 3,
    name: 'Electronic Arts',
    companyIcon:
      'https://ogdb-cdn.intlgame.cn/company/5a6207e2-b868-9f41-5178-8d51d2c40a93.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Redwood City  United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 4,
    name: 'Tencent',
    companyIcon:
      'https://ogdb-cdn.intlgame.cn/company/3cae090b-ed2d-95f8-79a9-e32ca480258f.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/cn.svg',
    conutryName: 'Shenzhen  China',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 5,
    name: 'Electronic Arts',
    companyIcon:
      'https://ogdb-cdn.intlgame.cn/company/5a6207e2-b868-9f41-5178-8d51d2c40a93.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Redwood City  United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 6,
    name: 'Electronic Arts',
    companyIcon:
      'https://ogdb-cdn.intlgame.cn/company/5a6207e2-b868-9f41-5178-8d51d2c40a93.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Redwood City  United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 7,
    name: 'Tencent',
    companyIcon:
      'https://ogdb-cdn.intlgame.cn/company/3cae090b-ed2d-95f8-79a9-e32ca480258f.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/cn.svg',
    conutryName: 'Shenzhen  China',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 8,
    name: 'Electronic Arts',
    companyIcon:
      'https://ogdb-cdn.intlgame.cn/company/5a6207e2-b868-9f41-5178-8d51d2c40a93.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Redwood City  United States',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 9,
    name: 'Tencent',
    companyIcon:
      'https://ogdb-cdn.intlgame.cn/company/3cae090b-ed2d-95f8-79a9-e32ca480258f.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/cn.svg',
    conutryName: 'Shenzhen  China',
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 10,
    name: 'Electronic Arts',
    companyIcon:
      'https://ogdb-cdn.intlgame.cn/company/5a6207e2-b868-9f41-5178-8d51d2c40a93.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Redwood City  United States',
    revenue: 5468465482,
    precent: 0.16,
  },
];

export const topConsoleGameList = [
  {
    rank: 1,
    name: 'Tribes of Midgard',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/6de588a3ac95a3da51c398cfe330f6ec.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Gearbox Publishing',
    platList: [
      nintendo,
      playstation,
      xbox,
    ],
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 2,
    name: 'Fortnite',
    gameIcon: 'https://ogdb-cdn.intlgame.cn/pic_by_handle/console/Fortnite.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Gearbox Publishing',
    platList: [
      nintendo,
      playstation,
      xbox,
    ],
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 3,
    name: 'Tribes of Midgard',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/6de588a3ac95a3da51c398cfe330f6ec.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Gearbox Publishing',
    platList: [
      nintendo,
      playstation,
      xbox,
    ],
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 4,
    name: 'Fortnite',
    gameIcon: 'https://ogdb-cdn.intlgame.cn/pic_by_handle/console/Fortnite.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Gearbox Publishing',
    platList: [
      nintendo,
      playstation,
      xbox,
    ],
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 5,
    name: 'Tribes of Midgard',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/6de588a3ac95a3da51c398cfe330f6ec.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Gearbox Publishing',
    platList: [
      nintendo,
      playstation,
      xbox,
    ],
    revenue: 5468465482,
    precent: 0.16,
  },
];

export const topConsoleGameList10 = [
  {
    rank: 1,
    name: 'Tribes of Midgard',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/6de588a3ac95a3da51c398cfe330f6ec.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Gearbox Publishing',
    platList: [
      nintendo,
      playstation,
      xbox,
    ],
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 2,
    name: 'Fortnite',
    gameIcon: 'https://ogdb-cdn.intlgame.cn/pic_by_handle/console/Fortnite.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Gearbox Publishing',
    platList: [
      nintendo,
      playstation,
      xbox,
    ],
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 3,
    name: 'Tribes of Midgard',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/6de588a3ac95a3da51c398cfe330f6ec.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Gearbox Publishing',
    platList: [
      nintendo,
      playstation,
      xbox,
    ],
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 4,
    name: 'Fortnite',
    gameIcon: 'https://ogdb-cdn.intlgame.cn/pic_by_handle/console/Fortnite.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Gearbox Publishing',
    platList: [
      nintendo,
      playstation,
      xbox,
    ],
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 5,
    name: 'Tribes of Midgard',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/6de588a3ac95a3da51c398cfe330f6ec.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Gearbox Publishing',
    platList: [
      nintendo,
      playstation,
      xbox,
    ],
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 6,
    name: 'Tribes of Midgard',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/6de588a3ac95a3da51c398cfe330f6ec.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Gearbox Publishing',
    platList: [
      nintendo,
      playstation,
      xbox,
    ],
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 7,
    name: 'Fortnite',
    gameIcon: 'https://ogdb-cdn.intlgame.cn/pic_by_handle/console/Fortnite.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Gearbox Publishing',
    platList: [
      nintendo,
      playstation,
      xbox,
    ],
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 8,
    name: 'Tribes of Midgard',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/6de588a3ac95a3da51c398cfe330f6ec.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Gearbox Publishing',
    platList: [
      nintendo,
      playstation,
      xbox,
    ],
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 9,
    name: 'Fortnite',
    gameIcon: 'https://ogdb-cdn.intlgame.cn/pic_by_handle/console/Fortnite.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Gearbox Publishing',
    platList: [
      nintendo,
      playstation,
      xbox,
    ],
    revenue: 5468465482,
    precent: 0.16,
  },
  {
    rank: 10,
    name: 'Tribes of Midgard',
    gameIcon:
      'https://ogdb-cdn.intlgame.cn/image/6de588a3ac95a3da51c398cfe330f6ec.jpg',
    conutryFlag:
      'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    conutryName: 'Gearbox Publishing',
    platList: [
      nintendo,
      playstation,
      xbox,
    ],
    revenue: 5468465482,
    precent: 0.16,
  },
];

export const treeChartsData = [
  {
    name: 'Mobile Gacha Game',
    children: [
      {
        name: 'Mobile Gacha Game1',
        value: 15963254,
      },
      {
        name: 'Mobile Gacha Game2',
        value: 597856168,
      },
      {
        name: 'Mobile Gacha Game3',
        value: 12545876,
      },
      {
        name: 'Mobile Gacha Game4',
        value: 9958221,
      },
      {
        name: 'Mobile Gacha Game5',
        value: 15963999,
      },
      {
        name: 'Mobile Gacha Game6',
        value: 19593254,
      },
      {
        name: 'Mobile Gacha Game7',
        value: 18000254,
      },
      {
        name: 'Mobile Gacha Game8',
        value: 5963254,
      },
      {
        name: 'Mobile Gacha Game9',
        value: 963254,
      },
    ],
  },
  {
    name: 'RPG Game',
    children: [
      {
        name: 'RPG Game1',
        value: 1592540,
        color: '#ff0',
      },
      {
        name: 'RPG Game2',
        value: 59781680,
        color: '#f0f',
      },
      {
        name: 'RPG Game3',
        value: 1258760,
        color: '#f00',
      },
      {
        name: 'RPG Game4',
        value: 4995210,
        color: '#0f0',
      },
      {
        name: 'RPG Game5',
        value: 1599990,
        color: '#0ff',
      },
      {
        name: 'RPG Game6',
        value: 1952540,
        color: '#00f',
      },
      {
        name: 'RPG Game7',
        value: 1802540,
        color: '#0ff0ff',
      },
      {
        name: 'RPG Game8',
        value: 25925400,
        color: '#fff',
      },
      {
        name: 'RPG Game9',
        value: 1965400,
        color: '#000',
      },
    ],
  },
  {
    name: 'Strategy Game',
    children: [
      {
        name: 'Strategy Game1',
        value: 15944254,
      },
      {
        name: 'Strategy Game2',
        value: 59733418,
      },
      {
        name: 'Strategy Game3',
        value: 12585276,
      },
      {
        name: 'Strategy Game4',
        value: 99523421,
      },
      {
        name: 'Strategy Game5',
        value: 15925999,
      },
      {
        name: 'Strategy Game6',
        value: 19522254,
      },
      {
        name: 'Strategy Game7',
        value: 18023254,
      },
      {
        name: 'Strategy Game8',
        value: 59223454,
      },
      {
        name: 'Strategy Game9',
        value: 96234454,
      },
    ],
  },
  {
    name: 'Mobile Casual Game',
    children: [
      {
        name: 'Mobile Casual Game1',
        value: 159446254,
      },
      {
        name: 'Mobile Casual Game2',
        value: 597834168,
      },
      {
        name: 'Mobile Casual Game3',
        value: 125852376,
      },
      {
        name: 'Mobile Casual Game4',
        value: 99523421,
      },
      {
        name: 'Mobile Casual Game5',
        value: 15923999,
      },
      {
        name: 'Mobile Casual Game6',
        value: 19522254,
      },
      {
        name: 'Mobile Casual Game7',
        value: 18023254,
      },
      {
        name: 'Mobile Casual Game8',
        value: 592233454,
      },
      {
        name: 'Mobile Casual Game9',
        value: 9623454,
      },
    ],
  },
  {
    name: 'Action Game',
    children: [
      {
        name: 'Action Game1',
        value: 15946254,
      },
      {
        name: 'Action Game2',
        value: 597334168,
      },
      {
        name: 'Action Game3',
        value: 12582376,
      },
      {
        name: 'Action Game4',
        value: 99523421,
      },
      {
        name: 'Action Game5',
        value: 15923999,
      },
      {
        name: 'Action Game6',
        value: 19523254,
      },
      {
        name: 'Action Game7',
        value: 18025254,
      },
      {
        name: 'Action Game8',
        value: 59223454,
      },
      {
        name: 'Action Game9',
        value: 9624454,
      },
    ],
  },
  {
    name: 'Simulation Game',
    children: [
      {
        name: 'Simulation Game1',
        value: 15946254,
      },
      {
        name: 'Simulation Game2',
        value: 597823368,
      },
      {
        name: 'Simulation Game3',
        value: 12585376,
      },
      {
        name: 'Simulation Game4',
        value: 9952421,
      },
      {
        name: 'Simulation Game5',
        value: 15923599,
      },
      {
        name: 'Simulation Game6',
        value: 19522354,
      },
      {
        name: 'Simulation Game7',
        value: 18023554,
      },
      {
        name: 'Simulation Game8',
        value: 59223454,
      },
      {
        name: 'Simulation Game9',
        value: 9623444,
      },
    ],
  },
  {
    name: 'Adventure Game',
    children: [
      {
        name: 'Adventure Game1',
        value: 15944624,
      },
      {
        name: 'Adventure Game2',
        value: 597824168,
      },
      {
        name: 'Adventure Game3',
        value: 12582376,
      },
      {
        name: 'Adventure Game4',
        value: 9952341,
      },
      {
        name: 'Adventure Game5',
        value: 15925999,
      },
      {
        name: 'Adventure Game6',
        value: 19522254,
      },
      {
        name: 'Adventure Game7',
        value: 18023254,
      },
      {
        name: 'Adventure Game8',
        value: 59223454,
      },
      {
        name: 'Adventure Game9',
        value: 9623454,
      },
    ],
  },
  {
    name: 'Sports Game',
    children: [
      {
        name: 'Sports Game1',
        value: 1594454,
      },
      {
        name: 'Sports Game2',
        value: 597824168,
      },
      {
        name: 'Sports Game3',
        value: 12582376,
      },
      {
        name: 'Sports Game4',
        value: 9953421,
      },
      {
        name: 'Sports Game5',
        value: 19235999,
      },
      {
        name: 'Sports Game6',
        value: 19523254,
      },
      {
        name: 'Sports Game7',
        value: 18023554,
      },
      {
        name: 'Sports Game8',
        value: 59223454,
      },
      {
        name: 'Sports Game9',
        value: 9623454,
      },
    ],
  },
  {
    name: 'Racing Game',
    value: 1095368777,
  },
];

export const lineAxias = [
  'Jan.2022',
  'Feb.2022',
  'Mar.2022',
  'Apr.2022',
  'May.2022',
  'Jun.2022',
];

export const lineChartsData = [
  {
    name: 'Mobile Gacha Game',
    type: 'line',
    stack: '总量',
    data: [2202256, 2324456, 2017894, 2344784, 1904644, 2304457],
  },
  {
    name: 'RPG Game',
    type: 'line',
    stack: '总量',
    data: [5202256, 5324456, 5017894, 5344784, 4904644, 5304457],
  },
  {
    name: 'Strategy Game',
    type: 'line',
    stack: '总量',
    data: [1202256, 1324456, 1017894, 1344784, 904644, 2304457],
  },
  {
    name: 'Action Game',
    type: 'line',
    stack: '总量',
    data: [902256, 1324456, 1017894, 1344784, 904644, 2304457],
  },
  {
    name: 'Mobile Casual Game',
    type: 'line',
    stack: '总量',
    data: [7202256, 7324456, 6017894, 7344784, 804644, 7304457],
  },
  {
    name: 'Simulation Game',
    type: 'line',
    stack: '总量',
    data: [120256, 132456, 107894, 134484, 90464, 230457],
  },
  {
    name: 'Adventure Game',
    type: 'line',
    stack: '总量',
    data: [1892256, 2024456, 1817894, 1944784, 2044644, 2304457],
  },
];
